import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';

var SvgActionError = function SvgActionError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 200 166",
    style: {
      enableBackground: 'new 0 0 200 166'
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, '.st0{fill:#FDFADC;}\n\t.st1{fill:#3A5E51;}\n\t.st2{fill:#324257;}\n\t.st3{fill:#80B27F;}\n\t.st4{fill:#629476;}\n\t.st5{fill:#C4D8B2;}\n\t.st6{fill:#3BB562;}\n\t.st7{clip-path:url(#SVGID_00000052093678148032252650000013599442970752965784_);}\n\t.st8{fill:#808397;}'), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.17 165.98c-12.82-.75-25.81-15.73-49.64-56.98-13.36-23.11-24.42-60.81-17.28-74.18 6.28-11.78 23.38-16.69 72.29-11.21 62.69 7.72 86.61 18.24 92.91 29.79 5.71 10.46 4.8 23.3-35.03 67.86-27.17 28.67-52.34 45.36-63.25 44.72z",
    style: {
      fill: '#FDFADC'
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.03 66.67c.93-.47 2.38.72 3.18.14.09-.07 3.99-5.91 4.06-6.02.68-1.08-.8-.95-1.47-2.29-.47-.95-3.12.6-3.6-.37-.34-.69-.61-1.34-.85-2.05-.25-.73-.74-1.92-.22-2.49.39-.43 1.05-.61 1.26-1.21.25-.71 3.43-4.73 3.1-5.44-.33-.73-4.38 1.78-4.85 1.11-1.85-2.62-4.59-4.75-5.43-7.99-.53-2.04 1.88-3.52 1.42-5.23-.27-1-4.45 2.61-5.23 1.96-1.34-1.1-2.92-2.57-4.3-1.53-1.02.76-2.05.35-3.22-.19-.86-.4-2.18-.97-2.64-1.9-.31-.63-.34-1.4-.72-2.03-.8-1.32-2.55-7.2-3.87-7.52-1.22-.29-3.19 4.74-3.74 6.02-.1.37-.12 1-.41 1.27-.65.6-2.83.09-3.69-.06-1.54-.27-1.92-1.66-2.9-2.62-1.03-1-3.84-5.46-5.02-5.38-.96.06-3.51 5.59-3.96 6.44-.11.21-.17.4-.2.68-.11 1.18 2.49 1.33 1.33 2.13-1.09.76-2.06 1.79-3.41 2.11-1.57.37-3.08-3.29-5.26-3.6-.34-.05-1.82 2.61-2.46 3.92-.7 1.43-1.82 3.37-1.68 4.75.13 1.23 1.39 2.15 2.64 2.64 1.8.7 1.99 2.6 2.09 4.36.05.87-1.66-.92-2.04-.03-.84 1.93-2.24 4.09-3.24 5.83-.05.09-.1.19-.14.3-.33.96.2 2.21.6 3.19.59 1.43 1.14 2.84 1.96 4.2.44.73.92 1.44 1.67 1.92.89.58 1.86.24 2.79.23 1.06-.01 2.43-.04 3.49.39 1.42.57 2.56 2.19 3.47 3.37.73.94 1.38 2.05 1.38 3.17.01.92-.69 1.78-1.09 2.52-.37.69-.99 1.32-1.08 2.1-.09.82.49 1.54 1.1 2.15.88.89 2.03 1.56 3.11 2.14.87.47 1.93 1.25 2.87 1.49 1.09.28 1.87-.61 2.39-1.27.93-1.19 1.73-1.61 3.42-1.25 1.21.26 2.42.52 3.59 1.01.97.4 2.16.56 2.82 1.51.51.74.58 1.66.73 2.46.2 1.04.87 1.67 1.74 2 .32.12.68.2 1.04.24 1.77.2 3.49.06 5.17-.18.93-.13 1.97-.22 2.43-.98.1-.16 3.82-5.69 3.86-5.92.16-.91-3.76 1.82-3.23.68.34-.73.37-.14 1.06-.49 1.02-.52 2.37-1.24 3.52-.8.68.26 1.47 1.43 2.26 1.63 1.1.28 2.42-.6 3.73-2.12.48-.56 4.46-6.36 4.64-7.02.22-.77-3.74 2.37-4.23 1.76-.73-.92-.49-2.03-.19-2.88.27-.74-.3-.59.45-.96zm-8.65-1.18c-5.7 5.61-17.28 4.09-25.52-3.17-7.9-6.97-9.67-16.59-4.26-21.7 5.37-5.07 16.09-4.08 24.27 2.4 8.53 6.75 11.15 16.9 5.51 22.47z",
    style: {
      fill: '#3A5E51'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.46 64.32c1.9-.27 3.31-1.65 4.21-3.26 2.25-4.06 1.75-9.03.21-13.27-.21.3-.41.6-.6.91.2 1.37.18 2.76-.41 3.98-.58 1.23-1.75 1.88-2.95 1.96.91 3.59.45 7.06-1.58 9.74.42.01.8-.02 1.12-.06z",
    style: {
      fill: '#324257'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.53 24.04c-.02-.02-.04-.05-.07-.07-.12.17-.24.33-.35.5.14-.14.28-.28.42-.43z",
    style: {
      fill: '#324257'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.28 59.14c-.17-.17-.34-.38-.47-.65-.47-.95-3.12.6-3.6-.37-.34-.69-.61-1.34-.85-2.05-.25-.73-.74-1.92-.22-2.49.39-.43 1.05-.61 1.26-1.21.08-.22.43-.75.87-1.4-.23-.08-.45-.25-.61-.53-.48-.86.16-2.11.64-3.05-1.17.47-2.41 1-2.66.65-.53-.75-1.12-1.45-1.73-2.16-.07.22-.2.42-.36.58-.34 2.84-.63 5.69-.96 8.53-.29 2.44-.28 5.13-1.86 7.16-.25.33-.71.4-1.11.31-.35.45-.87.55-1.32.4-.48.96-1.11 1.84-1.92 2.63-5.7 5.61-17.28 4.09-25.52-3.17-7.9-6.97-9.67-16.59-4.26-21.7 3.77-3.57 10.2-4.13 16.52-1.9-.06-2.39 2.98-3.31 6.09-3.66.08-.01-3.49-3.24-3.41-3.26-.07-.23-.16-.46-.29-.67-.8-1.32-2.55-7.2-3.87-7.52-1.22-.29-3.19 4.74-3.74 6.02-.1.37-.12 1-.41 1.27-.65.6-2.83.09-3.69-.06-1.54-.27-1.92-1.66-2.9-2.62-.41-.4-1.1-1.34-1.85-2.32a29.042 29.042 0 0 1-3.93 3.3c-.67.47-1.41.99-2.22 1.19-.43.1-.88-.05-1.18-.35.02 1.1 2.47 1.26 1.34 2.05-1.09.76-2.06 1.79-3.41 2.11-1.09.26-2.14-1.41-3.41-2.57-2.32 2.6-4.41 5.51-5.52 8.77.5.67 1.34 1.19 2.17 1.51.66.26 1.1.67 1.4 1.19.87-2.72 2.2-5.35 4.11-7.41.44-.59.96-1.11 1.59-1.46 1.14-.64 2.51.99 1.44 1.87-.37.31-.72.63-1.05.98-.17.23-.33.49-.47.74-.26.46-.48.94-.68 1.43.09-.13.19-.26.3-.38.62-.72 1.73-.26 1.99.52.15.44.15.86 0 1.3-.16.48-.52.73-.91.8-.94 1.91-1.29 4.78-3.6 5.38-.04.2-.16.4-.37.59-3.18 2.79-4.65 6.5-5.48 10.48.29.62.6 1.23.96 1.84.44.73.92 1.44 1.67 1.92.89.58 1.86.24 2.79.23 1.06-.01 2.43-.04 3.49.39 1.42.57 2.56 2.19 3.47 3.37.73.94 1.38 2.05 1.38 3.17.01.92-.69 1.78-1.09 2.52-.37.69-.99 1.32-1.08 2.1-.09.82.49 1.54 1.1 2.15.88.89 2.03 1.56 3.11 2.14.15.08.3.17.46.26.07-.82.27-1.63.52-2.41.53-1.66 1.3-3.27 2.18-4.78.41-.71 1.2-.69 1.72-.32.28-.28.59-.5.94-.66.56-.25 1.32-.19 1.63.43.81 1.59.22 3.59-.49 5.26-.1.38-.22.74-.34 1.09-.03.07-.05.14-.08.21.56-.28 1.22-.32 2.15-.12 1.21.26 2.42.52 3.59 1.01.97.4 2.16.56 2.82 1.51.51.74.58 1.66.73 2.46.14.74.51 1.27 1.03 1.63 1.05-3.83 3-8.07 7.06-9.03.86-.2 1.73.56 1.46 1.46-.06.2-.12.4-.19.59.16.21.34.36.54.49.11-.02.23-.04.36-.08.46-.16.88-.42 1.29-.67.66-.4 1.29-.08 1.59.44.8-.35 1.68-.59 2.46-.29.68.26 1.47 1.43 2.26 1.63.08.02.15.03.23.04.46-1.13 1.04-2.21 1.59-3.16.83-1.42 1.71-2.87 2.72-4.2-.19.04-.32.03-.39-.06-.73-.92-.49-2.03-.19-2.88.25-.73-.32-.58.43-.95.86-.43 2.16.55 2.99.24-.45-1.34.49-3.34 1.19-4.68.58-1.15 1.25-2.06 2.06-3.09z",
    style: {
      fill: '#324257'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166.62 55.34c-.48-.96-1.87-1.13-2.36-2.11-.35-.69-.62-1.35-.86-2.07-.25-.74-.74-1.94-.22-2.51.4-.44 1.06-.62 1.27-1.22.25-.72-.22-1.51-.54-2.23-.34-.74-.74-1.46-1.22-2.14-.37-.53-.77-1.17-1.3-1.57-.79-.59-1.42-.26-2.23-.24-1.43.04-4.71-3.39-4.13-4.76.25-.62.82-1.34.61-2.11-.28-1.01-1.5-2.05-2.29-2.7-1.35-1.11-2.95-2.6-4.34-1.55-1.03.77-2.07.36-3.25-.19-.87-.4-2.2-.98-2.67-1.92-.31-.63-.35-1.42-.73-2.05-.8-1.33-2.68-1.85-4.02-2.17-1.23-.29-3.29-.85-3.67.65-.1.38-.12 1.01-.42 1.28-.66.6-2.86.09-3.72-.06-1.56-.27-1.94-1.68-2.93-2.64-1.04-1.01-3.37-.85-4.55-.77-1.18.08-3.77.01-3.91 1.56-.11 1.19 1.71 2.31.54 3.12-1.1.77-2.08 1.81-3.45 2.13-1.59.38-3.93-1.82-5.82-.66-1.42.88-2.35 2.23-3.15 3.74-.87 1.63.32 2.82 2.04 3.73.66.35 1.69.69 2.18 1.26.68.79.8 2.29.85 3.16.05.88-.01 2.11-.22 2.93-.57 2.19-4.49 1.06-5.25 3.24-.34.97.2 2.23.61 3.23.59 1.45 1.15 2.87 1.98 4.24.45.74.93 1.45 1.69 1.94.9.58 1.88.24 2.82.23 1.07-.01 2.45-.04 3.53.39 1.44.57 2.58 2.22 3.51 3.41.74.95 1.39 2.07 1.4 3.2.01.93-.69 1.8-1.1 2.55-.38.69-1 1.34-1.09 2.12-.09.83.5 1.56 1.11 2.18.89.9 2.05 1.57 3.14 2.16.88.48 1.95 1.26 2.9 1.5 1.1.28 1.89-.61 2.42-1.28.94-1.2 1.75-1.63 3.45-1.27 1.22.26 2.44.53 3.63 1.02.98.4 2.19.56 2.85 1.52.52.75.59 1.68.74 2.49.2 1.05.87 1.69 1.76 2.02.33.12.68.2 1.06.24 1.78.2 3.53.06 5.22-.18 1.14-.16 2.44-.26 2.67-1.58.16-.92-.92-2.59-.38-3.73.34-.74 1.18-1.11 1.88-1.46 1.03-.53 2.4-1.25 3.56-.81.69.26 1.49 1.45 2.28 1.65 1.11.28 2.45-.61 3.77-2.14.49-.57.87-1.28 1.05-1.95.22-.78-.95-1.78-1.44-2.4-.74-.93-.49-2.05-.19-2.91.26-.73.48-1.55 1.24-1.93 1.04-.52 2.74 1.02 3.46-.13.63-1.12.9-4.1.23-5.45zm-13.13 5.47c-5.7 5.61-17.28 4.09-25.52-3.17-7.9-6.97-9.67-16.59-4.26-21.7 5.37-5.07 16.09-4.08 24.27 2.4 8.54 6.75 11.16 16.91 5.51 22.47z",
    style: {
      fill: '#80B27F'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M166.62 55.34c-.48-.96-1.87-1.13-2.36-2.11-.35-.69-.62-1.35-.86-2.07-.25-.74-.74-1.94-.22-2.51.4-.44 1.06-.62 1.27-1.22.25-.72-.22-1.51-.54-2.23-.34-.74-.74-1.46-1.22-2.14-.37-.53-.77-1.17-1.3-1.57-.79-.59-1.42-.26-2.23-.24-.1 0-.2-.01-.31-.04-.8-.19-1.57.41-1.52 1.23v.03c.09 1.43.05 2.87-.11 4.28-.36 2.99-.38 6-.23 9.01.12 2.37-.24 4.63-1.72 6.01-1.63 1.52-4.09 2.22-6.72 2.43-2.8.23-5.56.88-8.19 1.86-1.48.55-2.99 1.01-4.51 1.41-4.71 1.24-9.59 1.66-14.44 1.3-.46-.03-.73.51-.42.85.1.11.2.22.3.32.89.9 2.05 1.57 3.14 2.16.88.48 1.95 1.26 2.9 1.5 1.1.28 1.89-.61 2.42-1.28.94-1.2 1.75-1.63 3.45-1.27 1.22.26 2.44.53 3.63 1.02.98.4 2.19.56 2.85 1.52.52.75.59 1.68.74 2.49.2 1.05.87 1.69 1.76 2.02.33.12.68.2 1.06.24 1.78.2 3.53.06 5.22-.18 1.14-.16 2.44-.26 2.67-1.58.16-.92-.92-2.59-.38-3.73.34-.74 1.18-1.11 1.88-1.46 1.03-.53 2.4-1.25 3.56-.81.69.26 1.49 1.45 2.28 1.65 1.11.28 2.45-.61 3.77-2.14.49-.57.87-1.28 1.05-1.95.22-.78-.95-1.78-1.44-2.4-.74-.93-.49-2.05-.19-2.91.26-.73.48-1.55 1.24-1.93 1.04-.52 2.74 1.02 3.46-.13.66-1.1.93-4.08.26-5.43z",
    style: {
      fill: '#629476'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.82 109.51c-.54-1.76-5.75 1.09-6.31-.71a27.18 27.18 0 0 1-.87-3.8c-.22-1.36-.71-3.56.4-4.61.84-.8 2.07-1.13 2.63-2.23.66-1.32 7.61-8.73 7.26-10.05-.36-1.36-8.37 3.28-9 2.03-1.46-2.89-3.36-6.45-5.37-9.01-2.06-2.62-4.11-4.93-2.29-8.18 1.03-1.83 4.91-5.04 4.7-7.33-.17-1.86-8.76 4.8-9.95 3.61-2.03-2.04-4.39-4.77-7.18-2.86-2.06 1.41-3.76.64-5.67-.36-1.4-.74-3.58-1.8-4.1-3.54-.35-1.16-.17-2.6-.64-3.77-1-2.45-2.25-13.35-4.52-13.94-2.08-.54-7.19 8.77-8.59 11.13-.29.69-.53 1.85-1.14 2.34-1.35 1.1-5.08.15-6.55-.13-2.66-.5-2.9-3.08-4.35-4.86-1.52-1.86-5.12-10.13-7.24-9.99-1.73.12-6.32 8.57-7.38 10.13-.27.4-.43.75-.57 1.26-.57 2.18 2.3 4.24-.02 5.72-2.19 1.4-4.25 3.31-6.75 3.89-2.92.68-4.25-8.77-7.96-6.64-1.45.83-2.53 2.4-3.49 3.73-1.26 1.75-2.4 3.58-3.51 5.42-1.07 1.77-2.5 3.84-2.25 6.01.3 2.62 3.03 3.85 5.02 5.07.42.26 1.04.51 1.31.94.26.4.33 1.04.43 1.5.33 1.48.18 3.05 0 4.54-.19 1.62-4.39.06-5.35 1.69-2.1 3.57-3.57 5.8-5.9 9.02-.13.17-.24.36-.34.56-.9 1.77-.35 4.09.06 5.92.59 2.66 1.13 5.26 2.17 7.78.56 1.35 1.19 2.66 2.37 3.56 1.41 1.07 3.24.45 4.9.44 1.88-.01 4.34-.06 6.11.73 2.36 1.05 3.86 4.08 5.12 6.26 1.01 1.75 1.81 3.8 1.46 5.87-.28 1.71-1.79 3.29-2.75 4.67-.88 1.27-2.19 2.45-2.59 3.89-.41 1.51.39 2.85 1.28 4 1.28 1.65 3.13 2.89 4.87 3.97 1.4.88 3.04 2.32 4.64 2.77 1.85.52 3.53-1.11 4.67-2.34 2.04-2.19 3.6-2.98 6.49-2.31 2.07.48 4.15.98 6.08 1.88 1.6.75 3.68 1.04 4.55 2.8.68 1.38.51 3.08.52 4.57.02 1.93 1.01 3.1 2.47 3.71.54.22 1.15.37 1.79.45 3.09.37 6.21.12 9.28-.3 1.7-.23 3.57-.39 4.64-1.8.23-.3 6.9-8.75 7.04-9.18.57-1.69-7.28 3.34-5.98 1.24.84-1.35 2.43-2.02 3.78-2.68 1.99-.96 4.62-2.29 6.53-1.47 1.14.49 2.17 2.66 3.5 3.03 1.87.52 4.51-1.1 7.33-3.9 1.04-1.03 8.24-10 8.78-11.21.63-1.43-7.42 4.37-8.1 3.24-1.02-1.71-.23-3.76.57-5.33.68-1.34 1.34-2.84 2.79-3.53 1.8-.86 4.01 1.34 5.63.27.18-.12 7.27-9.15 7.43-9.37 1.57-1.96-1.12-1.72-1.89-4.21zm-27.25 12.07c-11.91 10.33-32.11 7.37-44.55-6.18-11.95-13.01-12.11-30.86-.87-40.27 11.15-9.34 29.98-7.37 42.57 4.74 13.12 12.62 14.66 31.47 2.85 41.71z",
    style: {
      fill: '#3A5E51'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.82 109.51c-.54-1.76-5.75 1.09-6.31-.71a27.18 27.18 0 0 1-.87-3.8c-.22-1.36-.71-3.56.4-4.61.84-.8 2.07-1.13 2.63-2.23.29-.57 1.76-2.29 3.3-4.16-.38-.2-.63-.62-.66-1.07-.1-1.33.21-2.77.81-4.09-2.3.89-4.85 1.97-5.19 1.28-1.46-2.89-3.36-6.45-5.37-9.01-.69-.88-1.38-1.73-1.93-2.58.09.71.18 1.43.24 2.15.04.41-.11.71-.34.9.13.91.25 1.81.36 2.72.29 2.55.45 5.13.26 7.69-.16 2.26-.54 4.74-1.97 6.59-1.18 1.53-2.98 2.11-4.8 1.89.9 7.98-1.61 15.73-7.81 21.11-11.91 10.33-32.11 7.37-44.55-6.18-11.95-13.01-12.11-30.86-.87-40.27 6.46-5.41 15.49-7.02 24.4-5.07-.11-1.02.03-2.09.38-3.02 1.54-4.12 6.55-4.41 10.33-4.06a9.262 9.262 0 0 0 1.42-3.36c-.06-.32-.13-.63-.25-.93-.71-1.74-1.55-7.74-2.78-11.29-1.26 1.02-2.55 1.96-4.13 2.32-.91.65-1.88 1.21-2.95 1.59-.19.07-.38.07-.55.04-1.17 1.89-2.17 3.67-2.68 4.53-.29.69-.53 1.85-1.14 2.34-1.35 1.1-5.08.15-6.55-.13-2.66-.5-2.9-3.08-4.35-4.86-1.22-1.49-3.77-7.09-5.83-9.19-1.29 1.56-2.56 3.14-3.8 4.75-1.38 1.8-2.74 3.62-4.03 5.48-.48.7-.91 1.45-1.39 2.18.49 1.49 1.49 2.85-.17 3.91-2.19 1.4-4.25 3.31-6.75 3.89-2.12.5-3.4-4.35-5.36-6.23-2.91 2.78-5.43 5.94-7.66 9.27-1.33 1.98-2.56 4.03-3.83 6.05-.05.09-.11.17-.16.26.72 2.07 3.07 3.16 4.83 4.24.15.09.33.19.51.29 2.78-5.71 7.7-10.5 13.87-12.25 1.48-.42 2.09 1.85.63 2.29-1.41.43-2.66 1.4-3.74 2.41-.74.69-1.44 1.43-2.09 2.2.02.22-.02.45-.14.69-.2.39-.4.79-.6 1.19.71.01 1.44.77 1.22 1.54-.14.47-.29.94-.44 1.4l.53-.41c.51-.38 1.34-.08 1.63.43.34.6.09 1.24-.43 1.63-.11.08-.21.16-.31.24-.03.06-.06.11-.1.17-1.19 1.78-2.49 3.53-4.27 4.77-.26.18-.56.21-.83.15-.47.43-1.01.78-1.63.98-.33.11-.68.03-.95-.15-1 .58-2.07 1.08-3.19 1.34 1.26 3.64 1.32 7.83 1.06 11.58-.16 2.3-.59 4.43-1.46 6.59-1.21 2.97-2.95 5.66-4.67 8.35.05.04.09.08.14.11 1.41 1.07 3.24.45 4.9.44 1.88-.01 4.34-.06 6.11.73 2.36 1.05 3.86 4.08 5.12 6.26 1.01 1.75 1.81 3.8 1.46 5.87-.01.06-.02.12-.04.18.14-.19.29-.37.43-.56.73-.93 1.55-1.83 2.14-2.85.46-.79.94-1.48 1.78-1.81.07-.05.15-.09.23-.12 2.28-.92 4.88-1.27 6.93.35 1.85 1.46 2.72 3.9 3.41 6.07.47 1.49.72 2.98.48 4.53-.21 1.4-.81 2.74-1.42 4-1.63 3.36-3.9 6.44-6.42 9.28 1.01-.47 1.91-1.37 2.61-2.12 2.04-2.19 3.6-2.98 6.49-2.31 2.07.48 4.15.98 6.08 1.88 1.6.75 3.68 1.04 4.55 2.8.68 1.38.51 3.08.52 4.57 0 .38.05.72.12 1.04.24-1.1.61-2.16 1.04-3.1 1.81-3.98 5.88-8 10.36-8.64.34-.05.67 0 .94.15.2-.02.42.02.64.14 2.11 1.08 4.52 1.64 6.84 2.05.66.12 1.34.22 2.02.31.36-.18.71-.34 1.05-.51 1.99-.96 4.62-2.29 6.53-1.47.79.34 1.54 1.5 2.37 2.3.4-1.19 1-2.33 1.62-3.39 1.58-2.67 3.58-5.02 5.95-6.95.42-.48.84-.95 1.29-1.4-.55-1.57.14-3.34.85-4.73.68-1.34 1.34-2.84 2.79-3.53 1.52-.73 3.34.74 4.84.56.26-2.93 1.81-5.78 3.61-8.02 1.22-1.52 2.75-2.86 4.52-3.58-.57-.49-1.43-1.05-1.81-2.29z",
    style: {
      fill: '#324257'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.06 103.67c-.55-1.78-2.98-2.1-3.54-3.92-.4-1.29-.67-2.51-.88-3.84-.22-1.37-.71-3.59.4-4.66.85-.81 2.09-1.14 2.65-2.25.67-1.33.09-2.8-.26-4.14-.37-1.37-.86-2.71-1.5-3.97-.49-.98-1-2.17-1.82-2.9-1.22-1.1-2.45-.5-3.9-.46-2.56.06-7.32-6.31-5.85-8.83.64-1.15 1.89-2.49 1.76-3.91-.17-1.88-2.02-3.8-3.22-5.01-2.05-2.06-4.43-4.82-7.26-2.89-2.08 1.42-3.8.65-5.73-.37-1.42-.74-3.62-1.82-4.14-3.57-.35-1.17-.17-2.63-.65-3.81-1.01-2.47-4.19-3.44-6.48-4.03-2.1-.54-5.59-1.59-6.76 1.19-.29.7-.53 1.86-1.15 2.37-1.37 1.11-5.13.16-6.62-.13-2.69-.51-2.93-3.11-4.39-4.91-1.53-1.88-5.74-1.59-7.88-1.45-2.13.14-6.72 0-7.46 2.86-.57 2.2 2.32 4.28-.02 5.78-2.21 1.41-4.29 3.34-6.82 3.93-2.95.69-6.43-3.4-10.17-1.24-2.81 1.62-4.91 4.13-6.81 6.9-2.06 3.01-.32 5.22 2.45 6.92 1.06.65 2.8 1.28 3.49 2.34.95 1.46.69 4.25.51 5.86-.19 1.63-.69 3.91-1.32 5.42-1.71 4.06-8.35 1.95-10.39 5.97-.91 1.79-.35 4.13.06 5.98.6 2.68 1.14 5.31 2.19 7.86.56 1.36 1.2 2.69 2.4 3.6 1.42 1.09 3.28.45 4.95.44 1.9-.01 4.38-.06 6.17.74 2.38 1.07 3.9 4.12 5.17 6.32 1.02 1.76 1.82 3.84 1.48 5.93-.28 1.72-1.81 3.32-2.78 4.72-.89 1.28-2.21 2.47-2.61 3.93-.42 1.53.4 2.88 1.3 4.04 1.29 1.66 3.16 2.92 4.92 4.01 1.42.88 3.07 2.34 4.69 2.79 1.87.52 3.56-1.13 4.72-2.36 2.06-2.22 3.64-3.01 6.55-2.33 2.09.49 4.19.99 6.14 1.9 1.61.75 3.72 1.05 4.59 2.83.68 1.4.51 3.11.53 4.61.02 1.95 1.02 3.13 2.49 3.74.55.23 1.16.37 1.8.45 3.12.38 6.27.12 9.37-.31 2.08-.29 4.43-.46 5.26-2.91.57-1.71-.81-4.79.5-6.92.84-1.37 2.45-2.04 3.82-2.7 2.01-.97 4.67-2.31 6.6-1.48 1.15.49 2.19 2.68 3.54 3.06 1.89.53 4.55-1.11 7.4-3.94 1.05-1.04 1.95-2.37 2.5-3.6.64-1.44-1.13-3.31-1.81-4.45-1.03-1.72-.23-3.8.58-5.39.69-1.36 1.35-2.87 2.82-3.57 2.02-.96 4.56 1.9 6.22-.23 1.54-1.98 2.97-7.49 2.2-10.01zm-25.04 10.8c-12.06 10.46-32.52 7.46-45.13-6.26-12.1-13.17-12.26-31.26-.88-40.79 11.3-9.46 30.37-7.47 43.13 4.8 13.28 12.78 14.83 31.88 2.88 42.25z",
    style: {
      fill: '#80B27F'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.91 56.53c-1.42-.74-3.62-1.82-4.14-3.57-.35-1.17-.17-2.63-.65-3.81-.84-2.06-3.2-3.08-5.28-3.7-.4-.12-.83-.02-1.13.27-1.86 1.75-3.93 3.3-6.01 4.71-6.19 4.2-13.08 7.21-19.52 11-6.29 3.7-11.97 8.4-16.97 13.71-7.4 7.86-13.77 17.72-15.92 28.41-.13.63.28 1.26.91 1.39 1.17.23 2.48-.1 3.69-.11 1.9-.01 4.38-.06 6.17.74 1.42.64 2.54 1.98 3.47 3.43.36.55 1.1.7 1.65.34 2.64-1.77 5.33-3.49 8.03-5.18.55-.35.71-1.07.37-1.63-7.61-12.31-6.38-26.88 3.44-35.1 9.51-7.96 24.52-7.81 36.64-.25.57.36 1.32.17 1.66-.42a66.86 66.86 0 0 0 4.16-8.76c-.22-.56-.35-.91-.57-1.47.01 0 0 0 0 0z",
    style: {
      fill: '#C4D8B2'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115.59 48.7c1.38-.84 2.8-1.6 4.26-2.29.57-.27.89-.87.82-1.49-.38-3.47.61-6.68 3.04-8.98 4.96-4.69 14.51-4.19 22.39 1.04.42.28.97.32 1.43.11.53-.25 1.06-.5 1.58-.76 1.38-.69 2.74-1.45 4.07-2.27.85-.53.94-1.74.16-2.37l-.01-.01c-1.35-1.11-2.95-2.6-4.34-1.55-1.03.77-2.07.36-3.25-.19-.87-.4-2.2-.98-2.67-1.92-.31-.63-.35-1.42-.73-2.05-.54-.9-1.58-1.43-2.6-1.78-.51-.17-1.08-.04-1.47.33-7.11 6.83-16.91 10.41-23.15 18.28a39.392 39.392 0 0 0-5.97 10.54c-.02.05-.02.11.01.16.06.11.22.13.3.04 1.8-1.88 3.91-3.48 6.13-4.84z",
    style: {
      fill: '#C4D8B2'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.22 137.03c-4.71-3.35-8.19-8.45-10.84-13.5-.03-.05-.06-.11-.08-.16-.79.98-1.67 1.96-1.98 3.1-.42 1.53.4 2.88 1.3 4.04 1.29 1.66 3.16 2.92 4.92 4.01 1.42.88 3.07 2.34 4.69 2.79.73.2 1.43.08 2.08-.22-.04-.03-.07-.04-.09-.06z",
    style: {
      fill: '#C4D8B2'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M134.06 103.67c-.55-1.78-2.98-2.1-3.54-3.92-.4-1.29-.67-2.51-.88-3.84-.22-1.37-.71-3.59.4-4.66.85-.81 2.09-1.14 2.65-2.25.67-1.33.09-2.8-.26-4.14-.37-1.37-.86-2.71-1.5-3.97-.49-.98-1-2.17-1.82-2.9-1.22-1.1-2.45-.5-3.9-.46-2.56.06-7.32-6.31-5.85-8.83.64-1.15 1.89-2.49 1.76-3.91-.17-1.88-2.02-3.8-3.22-5.01-2.05-2.06-4.43-4.82-7.26-2.89l-.02.01a2.36 2.36 0 0 0-.86 2.82c.94 2.35 1.83 4.73 2.67 7.12 2.36 6.76 4.43 13.62 4.75 20.82.06 1.39.07 2.79.01 4.18-.06 1.45.03 2.89.26 4.32 1.39 8.68-1.71 22.78-15.39 24.09-2.56.24-5.08.81-7.47 1.77-1.1.44-2.6.81-4.7.97-6.42.47-13.03-.42-19.28-1.81-5.27-1.18-10.41-2.84-15.43-4.82-1.1-.43-2.29.27-2.47 1.43v.03c-.28 1.72-1.81 3.32-2.78 4.72-.89 1.28-2.21 2.47-2.61 3.93-.42 1.53.4 2.88 1.3 4.04 1.29 1.66 3.16 2.92 4.92 4.01 1.42.88 3.07 2.34 4.69 2.79 1.87.52 3.56-1.13 4.72-2.36 2.06-2.22 3.64-3.01 6.55-2.33 2.09.49 4.19.99 6.14 1.9 1.61.75 3.72 1.05 4.59 2.83.68 1.4.51 3.11.53 4.61.02 1.95 1.02 3.13 2.49 3.74.55.23 1.16.37 1.8.45 3.12.38 6.27.12 9.37-.31 2.08-.29 4.43-.46 5.26-2.91.57-1.71-.81-4.79.5-6.92.84-1.37 2.45-2.04 3.82-2.7 2.01-.97 4.67-2.31 6.6-1.48 1.15.49 2.19 2.68 3.54 3.06 1.89.53 4.55-1.11 7.4-3.94 1.05-1.04 1.95-2.37 2.5-3.6.64-1.44-1.13-3.31-1.81-4.45-1.03-1.72-.23-3.8.58-5.39.69-1.36 1.35-2.87 2.82-3.57 2.02-.96 4.56 1.9 6.22-.23 1.55-2.01 2.98-7.52 2.21-10.04z",
    style: {
      fill: '#629476'
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M102.96 46.68a.71.71 0 0 1-.72-.69l-.52-11.77a.726.726 0 0 1 1.45-.07l.52 11.77c.02.4-.29.74-.69.76h-.04z",
    style: {
      fill: '#3BB562'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M99.44 44.92c-.35 0-.65-.25-.71-.6l-.75-4.26c-.07-.39.19-.77.59-.84.39-.07.77.19.84.59l.75 4.26c.07.39-.19.77-.59.84-.05.01-.09.01-.13.01z",
    style: {
      fill: '#3BB562'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M106.03 45.28c-.07 0-.15-.01-.22-.03a.726.726 0 0 1-.47-.91l1.79-5.61c.12-.38.53-.59.91-.47s.59.53.47.91l-1.79 5.61c-.09.3-.38.5-.69.5z",
    style: {
      fill: '#3BB562'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M137.58 95.54c-.27 0-.52-.15-.65-.4l-2.03-4.05a.726.726 0 0 1 .32-.97c.36-.18.79-.03.97.32l2.03 4.05c.18.36.03.79-.32.97a.61.61 0 0 1-.32.08z",
    style: {
      fill: '#3BB562'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M145.08 92.02c-.14 0-.27-.04-.4-.12l-8.1-5.31a.726.726 0 0 1-.21-1c.22-.33.67-.43 1-.21l8.1 5.31a.726.726 0 0 1-.39 1.33z",
    style: {
      fill: '#3BB562'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M105 5.59C103.31 3.1 100.46.97 97.34.37c-3.52-.67-8.1-.03-11.13 2.85-1.73 1.64-3.22 3.9-3.47 6.33-.02.17-.02.35-.01.52-.3-.02-.58-.01-.79.02-2.33.28-4.26 1.14-5.72 3.1-1.8 2.41-1.89 5.5-.41 8.1.6 1.06 1.5 1.94 2.58 2.52.57.31 1.19.53 1.82.66.33.07 1.57.35 1.83.11-1.74 1.57-1.85 4.9-.34 6.94 1.23 1.67 2.57 2.05 4.22 2.3.45.07 1.31.1 2.11.04-1.34 1.47-.78 3.69.88 4.73.67.42 1.53.59 2.31.67.6.06 2.21.2 3.19 1.03-.12-1.37-.25-2.96.45-4.21.76-1.36 2.36-2.34 3.81-2.79 2.52-.78 4.24-2.26 4.78-4.97.56-2.82-1.04-5.65-3.67-6.46 1.02-.07 2.91-1.08 4.11-2.16 1.12-1.01 2.07-2.51 2.57-4.03 1.07-3.21.53-7.17-1.46-10.08z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: 'visible',
      fill: '#A09DAC'
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136409630107538708430000014562696776980403634_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: 'visible'
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: 'url(#SVGID_00000136409630107538708430000014562696776980403634_)'
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M101.25 22.17c-.86-.14-1.63-.68-2.48-.91-.84-.22-1.69-.15-2.53-.38-.94-.25-2.12-.5-2.68-1.38-.53-.84-.39-1.79.18-2.57.56-.78 1.51-.73 2.4-.9 1.89-.37 3.84-1.17 5.23-2.54 1.94-1.91 2.07-4.04 1.95-6.59-.09-1.82-.62-3.16 1.07-4.39 1.61-1.16 3.98-.2 5.4.85 1.97 1.45 3.28 3.6 3.47 6.05.25 3.31-1.36 6.57-3.65 8.88-1.21 1.21-2.65 2.21-4.24 2.84-.79.32-1.6.62-2.39.93-.56.21-1.15.2-1.73.11z",
    style: {
      fill: '#808397'
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: 'url(#SVGID_00000136409630107538708430000014562696776980403634_)'
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M81.46 18.2c-2.03.24-4.25 1.53-5.04 3.35-.75 1.73-1.85 4.3.1 5.7.52.37 1.22.5 1.84.45.87-.06 1.53-.5 2.14-1.1 1.07-1.06 1.94-2.31 3.05-3.33.8-.74 4.03-1.5 3.44-3-.3-.76-1.63-1.44-2.35-1.72-.82-.32-1.72-.4-2.6-.39-.19.01-.39.02-.58.04z",
    style: {
      fill: '#808397'
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: 'url(#SVGID_00000136409630107538708430000014562696776980403634_)'
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M80.23 30.73c.89 1.73 3.67 2.12 4.84.62 1.05-1.36 1.75-2.97 3.4-3.73 1.14-.52 2.9-.67 3.81.41.8.96.21 2.43-.56 3.24-.94.97-2.37 1.2-3.37 2.09-.79.71-1.32 1.67-2.22 2.26-.71.47-1.71.85-2.57.8-2.31-.12-3.21-2.02-3.27-4.04",
    style: {
      fill: '#808397'
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: 'url(#SVGID_00000136409630107538708430000014562696776980403634_)'
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M102.95 23.16c1.81 1.61.68 5.09-.9 6.41-2.16 1.8-5.51 2.14-8.02 3.26-1.2.54-2.9 1.32-3.68 2.43-1.07 1.53-.35 3.81 1.51 4.19 1.39.28 2.45.33 3.42 1.41.47.52.84.67 1.57.54 1.38-.23 2.73-1.62 3.43-2.74 1.11-1.78 2.18-3.21 3.61-4.73 1.34-1.42 2.43-3.3 2.48-5.29.03-1.29-.85-6.17-3.42-5.48z",
    style: {
      fill: '#808397'
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: 'url(#SVGID_00000136409630107538708430000014562696776980403634_)'
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M79.89 9.95c.74.32 1.38.02 2.13-.04.29-.02.45.06.73.13.4.09.82.04 1.23.13.73.16 1.49.43 2.17.72 1.18.5 2.35 1.26 3.61.46 1.41-.9 1.39-2.87.19-3.93-.95-.82-1.86-1.43-2.24-2.69-.52-1.74.45-3.87 2.07-4.67 1.01-.5 1.24-2.05.48-3.07-1.08-1.46-3.02-1.8-4.74-1.5-4.43.76-7.83 5.12-8.49 9.36",
    style: {
      fill: '#808397'
    }
  })))));
};

var SvgActionLoadingClock = function SvgActionLoadingClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 200 166",
    style: {
      enableBackground: 'new 0 0 200 166'
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, '.st0{fill:#B5D2D6;}\n\t.st1{fill:#5F1E1B;}\n\t.st2{fill:#903B35;}\n\t.st3{fill:#E0DFD2;}\n\t.st4{fill:#E5966E;}\n\t.st5{fill:#98A38F;}\n\t.st6{fill:#FCF8F5;}\n\t.st7{fill:#28885C;}\n\t.st8{fill:#17603D;}\n\t.st9{fill:#B6BCB3;}'), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.8 72.3C31.1 78.1 26.2 84.5 26 92c-.1 5.7 2.5 11 5.3 15.9 7.6 13.5 16.9 26 27.5 37.3 9.5 10.1 18.1 21.5 33.5 20.6 10.5-.6 19.5-7.6 28.1-13.4 16.8-11.3 32.4-24.8 47.6-38.2 2.1-1.8 4.2-3.7 5.2-6.3 2.5-5.9-1.4-12.4-5.2-17.5-17.1-23-36.3-44.3-57.3-63.8-3.5-3.2-7.1-6.4-11.6-7.7-12.5-3.4-23.6 7.9-31.1 16.3-11 12.2-21.8 24.4-32.2 37.1z",
    style: {
      fill: '#B5D2D6'
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.3 75.5c4.7 28.4-5.9 57.5-32 60.6C87.7 140 61.5 121.2 57.6 89S72 33.6 98.4 27.4c24.7-5.9 49.2 19.7 53.9 48.1z",
    style: {
      fill: '#5F1E1B'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.5 74.4c4.7 28.4-12.4 55.8-38 61.1S73.8 119.1 70 86.9c-3.8-32.2 13.2-59.6 38-61.1s48.8 20.2 53.5 48.6z",
    style: {
      fill: '#903B35'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.8 74.6c4.7 28.4-12.4 55.8-38 61.1-25.7 5.4-53.1-15-57-47.2s16.6-61 41.5-62.5 48.8 20.2 53.5 48.6z",
    style: {
      fill: '#903B35'
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158.3 74.9c-4.2-25.3-26-44.6-48.7-43.2-.9.1-1.7.1-2.6.3-22.2 2.1-40.5 27.5-37.1 55.7 3.3 27.8 27 44.2 49.8 40.8 1.2-.1 2.9-.4 4.2-.6 23.5-4.8 38.6-27.7 34.4-53z",
    style: {
      fill: '#E0DFD2'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.6 32.1c-6.6.9-12.8 3.7-17.9 7.8-5.1 4.1-9.3 9.3-12.3 15.1-6.1 11.6-7.9 25.3-5 38 1.4 6.3 4.1 12.4 7.9 17.6 1.9 2.6 4.1 5 6.5 7.2.6.5 1.2 1 1.9 1.6.7.5 1.3 1 2 1.4.7.4 1.3.9 2 1.3l1 .6c.3.2.7.4 1.1.6 5.7 3.1 12.1 5 18.7 5.2.8.1 1.6 0 2.5 0 .8 0 1.6-.1 2.5-.1 1.6-.2 3.3-.3 4.9-.5 1.6-.2 3.2-.6 4.8-1 1.6-.4 3.2-.9 4.7-1.6-3 1.4-6.2 2.5-9.5 3.1-1.6.3-3.3.5-4.9.7-.8.1-1.7.2-2.5.2s-1.7.1-2.5.1c-3.4 0-6.7-.5-10-1.3s-6.4-2-9.4-3.6c-6-3.1-11.2-7.6-15.3-13-4-5.4-6.9-11.7-8.3-18.3-.7-3.3-1.1-6.7-1.3-10-.1-3.4 0-6.7.5-10.1 1-6.7 3.1-13.2 6.4-19 1.6-2.9 3.5-5.7 5.7-8.3 2.2-2.5 4.6-4.9 7.3-6.8 2.7-2 5.6-3.7 8.8-4.9.8-.3 1.6-.6 2.4-.8l1.2-.4 1.2-.3c.8-.2 1.6-.3 2.5-.5.4-.1.8-.1 1.2-.1l1.2.1z",
    style: {
      fill: '#E5966E'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M111.9 92.2 94.2 51.3c-.4-1 0-2.2.9-2.8l.9-.5 15.9 44.2z",
    style: {
      fill: '#98A38F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.5 97.6c-2.6-5.9-3.3-15.1-2.3-21.5 1.6-11.1 5.5-19.3 13.8-28v-3.5c-1.6 1-4.7 4.1-5.8 5.5-2.6 3.4-5 7.3-6.6 11.1-3.2 7.6-4.1 15.8-3.2 23.7.5 4.4 2.3 8.6 4.1 12.7z",
    style: {
      fill: '#FCF8F5'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m112.5 90.9 24.6-10.3c1.3-.5 2.1-1.9 1.9-3.3l-26.5 13.6z",
    style: {
      fill: '#98A38F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m112.8 91.6 29.1-14.9c.9-.5.4-1.9-.7-1.6L111.9 84l.9 7.6z",
    style: {
      fill: '#28885C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.8 91.6c-.5.3-1.2 0-1.4-.5l-16.3-45c-.5-1.5 1.6-2.3 2.3-1 8.7 16.3 23 42.6 23 42.6.2-.4-5.3 2.7-7.6 3.9z",
    style: {
      fill: '#28885C'
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "117.5,82.3 120.4,87.6 121.9,86.8",
    style: {
      fill: '#17603D'
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-36.908 114.611 85.493)",
    className: "st8",
    cx: 114.6,
    cy: 85.5,
    rx: 1.7,
    ry: 2.1,
    style: {
      fill: '#17603D'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91 98.4c-2.8-4.3-4.4-11.3-4.4-16.4 0-8.8 2.6-15.8 8.2-23.6l-1.5-1.8c-1.3 1.6-3 4.2-3.7 5.4-1.7 3-2.6 5.8-3.5 9-1.7 6.3-1.2 12 .5 18 1.1 3.4 2.5 6.5 4.4 9.4z",
    style: {
      fill: '#FCF8F5'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M113.5 117.8c-4.9-.9-9.3-2.4-13.9-5.5-2.7-1.8-6.6-6.3-10-6.2-5.6 0-3.8 5-1.8 8 2 3.1 5.1 5.4 8.4 7.1 6.6 3.4 14.7 4.8 22 3.8 1.9-.3 4.7-.3 5.8-2.2 1.9-3.2-1.1-3.7-3.5-4-2.5-.3-4.8-.6-7-1z",
    style: {
      fill: '#B6BCB3'
    }
  })))));
};

var SvgActionNotFound = function SvgActionNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 200 166",
    style: {
      enableBackground: 'new 0 0 200 166'
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, '.st0{fill:#FFE99A;}\n\t.st1{fill:#88C9D1;}\n\t.st2{fill:#3692BA;}\n\t.st3{fill:none;}\n\t.st4{fill:#293F46;}\n\t.st5{fill:#0C2026;}\n\t.st6{fill:#1F5835;}\n\t.st7{fill:#1E9A48;}\n\t.st8{fill:#3B545C;}\n\t.st9{fill:#CA7B6C;}\n\t.st10{fill:#F6B694;}\n\t.st11{fill:#F8F0F6;}\n\t.st12{fill:#3E101B;}\n\t.st13{fill:#641A26;}\n\t.st14{fill:#81363F;}\n\t.st15{fill:#521C2A;}\n\t.st16{fill:#2C0007;}\n\t.st17{fill:#828B87;}\n\t.st18{fill:#003623;}\n\t.st19{opacity:0.54;fill:#006028;enable-background:new    ;}\n\t.st20{fill:#D4DFD4;}\n\t.st21{opacity:0.65;fill:#FFFFFF;enable-background:new    ;}\n\t.st22{opacity:0.4;fill:#14823C;enable-background:new    ;}\n\t.st23{fill:#9AA69F;}\n\t.st24{fill:#CFD1CA;}\n\t.st25{fill:#A34B56;}\n\t.st26{fill:#FFFFFF;}'), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8 2.4c12.2-2.2 38.1 18.9 65.5 58.1 15.3 21.9 35.9 56.4 30.4 68.5s-28.6 20.7-70.4 29c-40.7 8.1-89.7 13-100.4.2-8.8-10.6-.3-42.3 20.6-86.3C56.7 31.6 79.7 4.6 91.8 2.4z",
    style: {
      fill: '#FFE99A'
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.4 27.4c.3.2.9-.7 6.9-3 4.9-1.9 6.3-4.3 5.8-6.1-.6-2.4-4.6-.6-7.5 2.1-3 2.8-5.6 6.7-5.2 7z",
    style: {
      fill: '#88C9D1'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.4 31.5c-.1.5.7.2 3 1.4 2.7 1.4 3.3 3.3 5.9 2.7 2.8-.7 2.7-3-.5-4.3-3.2-1.1-8.3-.3-8.4.2z",
    style: {
      fill: '#88C9D1'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.1 18.3c0-.1-.1-.2-.1-.3-.1.2-.1.4-.2.6-.6 1.1-1.7 2.1-2.7 2.8-1.3 1-2.7 1.8-4 2.6-1.4.8-2.8 1.5-4.2 2.3-.5.2-.9.5-1.4.7-.1.2-.1.4 0 .5.3.2.9-.7 6.9-3 4.8-2 6.2-4.4 5.7-6.2z",
    style: {
      fill: '#3692BA'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.8 34.6c-1.5-.3-2.7-.8-3.9-1.4-2.6-1.2-3.7-1.2-5.5-1.8 0 0 0 .1-.1.1-.1.5.7.2 3 1.4 2.7 1.4 3.3 3.3 5.9 2.7.8-.2 1.4-.5 1.7-.9-.2 0-.6 0-1.1-.1z",
    style: {
      fill: '#3692BA'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.8 64.1c2.2-1.2 4.7-2.6 7.2-2.9.3 0 .6 0 .8.1-.1-1.3-.3-2.5-.6-3.5-.8.1-1.6 0-2.5-.1C77 56.5 71.5 50 74.5 43c.7-1.6 2-2.7 3.4-3.2-1.6-2.5-4.5-7.7-3.9-12.7-.3-.6-.7-1.4-1-2.3-.1.1-.2.2-.4.3l.1-.1c-.6.5-1.3.9-2.1 1.2V26.5c-.1.6-1.1 1.3-2.5 1.9-2.1.9-5 1.6-6.1 1.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1h-.1c-.1-.1-.1-.1-.1-.2-.2-.4.1-1.1 1.2-2.2-6.2 4.6-9.4 6.8-13.3 6.2-.2 1.9-.5 3.6-.6 4.3-.1.4-.2.7-.3 1.1-.9 5.2-2.9 13.1-5.6 22.1l-.3 1.2-1.5 4.8c-.2.6-.7 2.4-1.4 5 1.9-1.4 3.8-2.8 5.7-4.1 1.9-1.3 3.9-2.3 5.9-3.2 3.1-1.4 8.1-3 11.4-2.7h.3c4.8 0 8.6 1.8 12.6 4.4.2.1.4.2.5.4v-.1c.2-1.3.7-1.7 1.6-2.2z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M170.4 95.6c-1.2-5.6-2.6-11.1-4-16.7-1.1-4.3-2.3-8.7-3.6-13-.3-.9-.5-1.7-.8-2.6-.2-.5-.3-1.1-.7-1.5-.4-.4-.9-.6-1.4-.8-1.8-.7-3.7-1.4-5.5-2.1-.9-.3-1.8-.7-2.7-.9-.4-.1-.9-.2-1.2.1-.2.2-.2.5-.3.8-.2 2.9.3 5.4.6 8.3.3 2.7-.2 5.7-.1 8.3v.1c-1.2-1.8-2.3-3.4-3.4-4.7-5.3-6.4-9.6-7.4-12.2-7.6-10.1-1.5-18.9 4.6-28.4 6.5-7.5 1.5-15.4 1.2-22.8-.9-7.2-2-13.2-7.6-20.9-7.7h-.3c-3.3-.4-8.3 1.3-11.4 2.7-2 .9-4 1.9-5.9 3.2-1.9 1.3-3.8 2.7-5.7 4.1.7-2.5 1.2-4.4 1.4-5l1.5-4.8.3-1.2c2.7-9 4.7-17 5.6-22.1-2.1 7.2-6.3 9.6-10 8.7-.2 0-.3-.1-.5-.2-3-1.1-5.5-4.6-5.6-10-.1-.7 0-2 .1-2.9v-.2c-3.1 4.5-6.5 9.8-9.6 15.2-2.9 5.1-5.4 9.8-8.1 14.8-2.5 4.8-4.9 10-7 16C6.1 84.9 4.5 90.6 4 96.1c-.2 1.9-.2 3.8-.1 5.6v-.2c0 3.1 0 6.2.9 9.2.3.9.7 1.9 1.1 2.9.5 1 1.6 2.8 2.9 3.4 3.9 1.6 7.9.4 11.7-.8 8-2.6 18.5-8.7 25.6-13.2 1.8-1.1 3.5-2.4 5.2-3.6 1.4 3.9 2.6 8 3.5 12.4 1 4.4 1.6 9.5 2.1 14 1.4 13.2 2 28.5 2.2 39.8 8.8-.4 18.4-1.4 28.1-2.8 10-1.4 20.1-3.1 29.7-5 3.6-.7 7.1-1.4 10.5-2.2 3.8-.8 7.5-1.7 11-2.5l.3-5.1c.6-9 1.1-18.7 1.4-28.1 1.8 3.2 3.7 6.4 5.6 9.6 2.3 3.8 5.2 7.5 8 11 1.8 2.3 3.6 4.4 5.6 6.5 1.5 1.5 3.3 2.9 5.2 3.7.4.2.8.5 1.2.6l.9.3c19.9 5.6 3.8-56 3.8-56z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M150.8 103.1c.2 11.5.9 23.1 3.4 32.1.3 1 1.7.7 1.5-.4-3.7-21.8 2.9-52.7 5.2-62.7-.8.8-1.9 1.4-3.4 1.6h-.7c-4.9.2-5.8-5.4-6.1-7.2l-.1.2c.2 2.5.1 5.9.2 9v.1c.1 8-.1 17.6 0 27.3z",
    style: {
      fill: '#0C2026'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M161.1 72z",
    style: {
      fill: '#1F5835'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M156.9 73.8c-.6 0-1.2 0-1.7-.2 1.2-4 1.9-8.2 2.2-11.1-.9 0-1.8 0-2.6-.1-2.2-.3-2.8-.9-2.9-1-.5-.7-1.2-1.6-1.5-2.5-.1.9-.1 1.8-.1 2.8 0 1.7.2 3.4.3 4.9 0 0 0 .2.1.6.2 1.9 1.3 6.8 6.2 6.6z",
    style: {
      fill: '#1F5835'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M157.6 73.7h-.3.3z",
    style: {
      fill: '#1F5835'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M157.2 73.7h-.3c.1.1.2.1.3 0z",
    style: {
      fill: '#1F5835'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M160.6 62.3c-.7 0-1.1 0-2.1.1-.4 0-.7.1-1.1.1-.4 2.9-1 7.1-2.2 11.1.5.1 1.1.2 1.7.2h.7c1.4-.2 2.5-.8 3.4-1.6l.1-.1c1.2-1.3 1.9-3 2.2-4.6-.4-1.4-.9-3.2-1.4-5.1-.4-.1-.9-.1-1.3-.1z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M166.5 149.4c-1.2.6-3-.2-3-.2-.5.1.3.9 1.3 1.5.4.2.8.5 1.2.6l.9.3c19.5 5.6 3.4-56.1 3.4-56.1v.1c.4 2.5 5.3 50.1-3.8 53.8z",
    style: {
      fill: '#3B545C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.9 98.3c-.1.1-.2.1-.3.2 0-.1-.1-.2-.1-.2 0-.1-.1-.1-.1-.2 1.6 4.1 2.7 7.2 3.2 8.6.3-.2.7-.3 1.1-.4h.7c.2-1.3.5-3.5.9-6.3l-1.2 1.7-4.2-3.4z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m138.8 153.3.3-5.1c-.1 1.7-.3 3.4-.3 5.1-.1 0-.1 0 0 0z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.3 72.9c0 2.2-.3 4.4-.8 6.3-.3 1-.6 1.9-1 2.7 6.8 10.1 16.9 32.4 10.7 71-.2 1-.3 2-.5 2.9 3.8-.8 7.5-1.7 11-2.5l.3-5.1c.6-9 1.1-18.7 1.4-28.1.2-6.3.3-12.5.4-18.4.2-1.8 2-13.4 10 1.5-.1-9.7.1-19.3 0-27.3-1.2-1.8-2.3-3.4-3.4-4.7-5.3-6.4-9.6-7.4-12.2-7.6-4.2-.6-12.1.3-18.3 3.5 1.4 1.6 2.4 3.6 2.4 5.8z",
    style: {
      fill: '#3B545C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M118.3 30c-.6-2.2-1.5-4.4-2.4-6.5-.4-1.1-.8-2.3-1.4-3.3-.5-.8-1.7-1.4-2.6-1.9-3.2-1.8-6.8-3-10.4-3-3.7 0-7.4 1.4-9.9 4-1.8 1.9-2.8 4.4-2.9 7 0 1.3.4 2.5.6 3.7.3 1.6.4 3.2.3 4.8-.1 1.7-.5 3.3-1 4.9-.2.7-1 3.5-1.8 3.5H86.5c1.5 4.7.2 9.7-1.9 14.2h.4c.3 1 .5 2.2.6 3.5.3.1.5.3.8.6l.7.8.3.3 3.8 4.4.6.7.7.8 4.7 5.4 1.2 1.3h.1s1.7 5.8 3.1 11.6l.6.5 2 1.6 1.6-2.2c.4-2.4.8-4.9 1.2-7 .5-3.1.9-5.4.9-5.4.1-.3.7-1.9 1.2-3.9.2-.8.4-1.6.5-2.4.1-.8.1-1.5.1-2.1-.1-2 0-3.7.5-4 6-2.4 9.3-7.8 10.1-14 .8-6-.3-12.2-2-17.9z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M85.3 57.7c.3 1 .5 2.2.6 3.5-.1-1.2-.3-2.5-.6-3.5z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.6 43.1z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88 42.4c0-.1.1-.2.1-.2s-.1.1-.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.9 42.6c0-.1.1-.1.1-.2 0 0-.1.1-.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.7 43c0-.1 0-.1 0 0 0-.1 0-.1 0 0z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.8 42.8s0-.1 0 0c0-.1 0-.1 0 0z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.3 41.5c0-.1 0-.1.1-.2 0 .1 0 .2-.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.2 41.8c0-.1.1-.1.1-.2 0 .1 0 .2-.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.1 42.1c0-.1.1-.1.1-.2 0 .1 0 .1-.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.5 41.3c0-.1 0-.1.1-.2-.1 0-.1.1-.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M86.7 43.6z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M86.9 43.6c.1 0 .1 0 0 0 .1 0 .1 0 0 0z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M86.8 43.6z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.5 43.3c0-.1 0-.1 0 0 0-.1 0-.1 0 0z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M86.6 43.5z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87 43.6c.1 0 .1 0 0 0 .1 0 .1 0 0 0z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.3 43.5s0-.1 0 0c0-.1 0 0 0 0z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.1 43.5c.1 0 .1 0 0 0 .1 0 .1 0 0 0z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.1 25.8c0-.1-.1-.2-.1-.2s.1.1.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.1 28.6c0-.1-.1-.2-.1-.3.1.1.1.2.1.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.4 43.3s0 .1 0 0c0 .1 0 0 0 0z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89 28.2c0-.1-.1-.2-.1-.3.1.1.1.2.1.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.2 29.1c0-.1-.1-.2-.1-.3.1.1.1.2.1.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.5 31c0-.5-.1-.9-.2-1.4.1.5.2.9.2 1.4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.3 29.6c0-.1-.1-.3-.1-.4.1.1.1.3.1.4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.6 31.4V31v.4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.9 27.8c0-.1-.1-.2-.1-.3 0 .1.1.2.1.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.6 27c0-.1-.1-.2-.1-.2.1 0 .1.1.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.8 27.4c0-.1-.1-.2-.1-.3 0 .1 0 .2.1.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M86.9 43.6z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.8 25.2c0 .1.1.1.1.2 0 0-.1-.1-.1-.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.7 33.4v.3-.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.6 31.9v-.4.4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.5 26.6c0-.1-.1-.2-.1-.2s0 .1.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.3 26.2c0-.1-.1-.2-.1-.2s.1.1.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.6 41c0-.1 0-.1.1-.2-.1 0-.1.1-.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.2 38.5c0-.1 0-.3.1-.4-.1.2-.1.3-.1.4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.6 34.6v-.4c.1.2 0 .3 0 .4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m89.2 38.1.3-2.1c0 .7-.1 1.5-.3 2.1z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.6 35.1v-.4.4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.5 36v-.4c.1.1.1.3 0 .4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.7 40.3c0-.1 0-.2.1-.2 0 .1 0 .1-.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.9 39.6c0-.1 0-.2.1-.3 0 .1 0 .2-.1.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89 39.3c0-.1 0-.2.1-.3 0 .1-.1.2-.1.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.1 38.9c0-.1 0-.2.1-.3-.1.1-.1.2-.1.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.8 40c0-.1 0-.2.1-.3 0 .1 0 .2-.1.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.6 35.5v-.4.4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.7 33.2v-.3.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.7 40.6c0-.1 0-.2.1-.2-.1.1-.1.2-.1.2z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.7 34.2v-.3.3z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.6 32.3v-.4.4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.7 32.8v-.4.4z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M115.7 22.4c-.5-1.3-.9-2.6-1.4-3.9l-6.3 2.4c3.4 6.5 6.5 13.4 7.5 20.7 1.1 7.4-.6 15-7.2 19.2-.6.4-.8 1.1-.5 1.7.8 1.8 1.3 4.9 1.5 8.1.2-.8.4-1.6.5-2.4v-.1c.1-.8.1-1.5.1-2.1-.1-2 0-3.7.5-4 2.6-1.1 4.9-2.8 6.6-5 4-5.3 4-12.4 3.1-18.7-.8-5.5-2.5-10.7-4.4-15.9z",
    style: {
      fill: '#F6B694'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M103.4 49.8c3.3-.1 4.3-2.2 4.5-3.3l-8.8.1c.7 1.2 1.9 3.3 4.3 3.2z",
    style: {
      fill: '#F8F0F6'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M100.1 37.8c0 .3.1.7.2 1 .1.4.3.6.6.6.3-.1.4-.3.5-.7.1-.5.2-.9.2-1.4 0-1.6-.1-3.1-.3-4.6-.1-.4-.2-.8-.3-1.1-.1-.2-.1-.3-.2-.4-.2-.2-.4-.4-.6-.2-.2.1-.3.4-.3.7v1.9c-.1 1.4 0 2.8.2 4.2z",
    style: {
      fill: '#3E101B'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.3 32.7c.3 1.5.6 3 .9 4.6.1.5.2.9.4 1.3.2.5.4.8.8.7.2-.2.3-.6.3-1-.1-.9-.2-1.8-.4-2.7-.2-1.2-.5-2.3-.9-3.3-.3-1.1-1.5-2.1-1.1-.2v.6z",
    style: {
      fill: '#3E101B'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M105.9 41.7c.2.2.5.2.7 0l1.5-1.5 1 5.4-9.8.1h-.1c-.2.1-.4.3-.4.5 0 .1 0 .2.1.2.4 1.5 1.9 4 4.7 3.9h.3c3.3-.2 4.2-2.7 4.4-3.7h1.4c.1 0 .3-.1.4-.2.1-.1.1-.3.1-.4l-1.3-7.1c0-.2-.2-.4-.4-.4-.2-.1-.4 0-.5.1l-2.2 2.2c-.2.3-.1.7.1.9zm1.4 5c-.2.9-1.1 2.7-3.7 2.7-2 .1-3.1-1.7-3.5-2.6l7.2-.1z",
    style: {
      fill: '#641A26'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.7 98.5c.1-.1.2-.1.3-.2l-.7-.6c0 .1.1.2.1.3 0 .1.1.1.1.2.1.1.1.2.2.3z",
    style: {
      fill: '#81363F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M106 86.9c.4-2.4.8-4.9 1.2-7-1.2 1.6-3.3 5.3-4.8 7.6l2 1.6 1.6-2.2z",
    style: {
      fill: '#81363F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.2 61.3c-5.9-3.1-8.4-9.3-8.7-15.7-.2-5.8 1-11.6 2.8-17 .7-2 2.3-4.6.1-6.3-1.1-.9-2.7-.9-4.1-.6-2.6.7-4.9 2.8-5.6 5.4-.6 2.2-.2 4.4 0 6.6.2 2.4.4 4.8.4 7.2 0 .3 0 .8.1 1.2 2.1 4.9.8 10.3-1.5 15.2h.1c.3 1 .5 2.2.6 3.5.3.1.5.3.8.6l.7.8.3.3 3.8 4.4.6.7.7.8 4.7 5.4c-.1-3.8.5-7.9 4.3-11.2.5-.3.4-1-.1-1.3z",
    style: {
      fill: '#81363F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M83.1 11.9s-.1 0 0 0c-.1 0-.1 0 0 0-.1 0 0 0 0 0z",
    style: {
      fill: '#521C2A'
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M75.2 15.8z",
    style: {
      fill: '#81363F'
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M75.2 15.8z",
    style: {
      fill: '#2C0007'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M110.1 81.3c-.7-1.6-1.4-3.8-2.1-6.7 0 0-.4 2.3-.9 5.4-.4 2.1-.8 4.6-1.2 7l4.2-5.7z",
    style: {
      fill: '#828B87'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M101.7 87.1c-1.4-5.8-3.1-11.6-3.1-11.6h-.1c0 .1-.1 2-3.7 6.2l6.9 5.4z",
    style: {
      fill: '#828B87'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M91 89.2c-.1-.2-.2-.5-.3-.7v-.1c-.2-.5-.4-1.1-.7-1.6 0-.1-.1-.2-.1-.3-.6.2-1.1.4-1.7.3l-.3.4 3.4 2.7c-.1-.2-.1-.3-.2-.5-.1-.1-.1-.2-.1-.2z",
    style: {
      fill: '#003623'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m101.3 97.8.7.6 4.1 3.4 1.2-1.7c.5-3 1.1-6.8 1.9-11.1.2-.8.5-2.2.8-3.8l.6-3c-.1-.2-.2-.5-.4-.8L106 87l-1.6 2.2-2-1.6-.6-.5-6.8-5.4-.1.1c2.5 6.2 4.7 11.6 6.4 16z",
    style: {
      fill: '#003623'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M116.3 85.5c-.2.9-.3 1.8-.4 2.3l1.6-2.3c-.2-.8-.5-1.5-.8-2.1-.1.7-.3 1.4-.4 2.1z",
    style: {
      fill: '#003623'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m110.5 82.1-.6 3c-.3 1.3-.5 2.6-.7 3.9-.8 4.3-1.4 8.1-1.9 11.1-.4 2.8-.8 5-.9 6.3.3.1.7.2 1 .4.3.2.6.5.8.9 1.8-.3 3.1-.9 3.8-1.2.3-.2.5-.5.6-.8.2-1.6 1.8-9.6 3.4-17.5 0-.1 0-.2.1-.3.2-.8.3-1.5.5-2.3.1-.7.3-1.5.4-2.1-2 2.4-4.4 2.7-6.5-1.4z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.7 83.3c0 .1 0 .1 0 0-.1.7-.3 1.5-.4 2.2.1-.7.3-1.4.4-2.2z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m110.5 82.1-.6 3 .6-3z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.9 91.4c0-.1-.1-.1-.1-.2 0 0 .1.1.1.2z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.7 90.8c-.1-.2-.2-.4-.2-.6 0 .2.1.4.2.6z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.4 98.1c0-.1-.1-.2-.1-.3-1.3-3.4-2.9-7.5-4.8-12-.1-.2-.1-.3-.2-.5-.3-.8-.7-1.6-1-2.4 0-.1-.1-.2-.1-.3-.1-.3-.2-.5-.3-.8l-.3.3c-.9 1-1.9 2.1-3.2 3.3-.5.5-1 .8-1.5 1 0 .1.1.2.1.3.2.5.4 1.1.7 1.6v.1c.1.2.2.5.3.7 0 .1.1.1.1.2.1.2.1.3.2.5 0 .1.1.2.1.3.1.2.2.4.2.6.1.1.1.3.2.4 0 .1.1.1.1.2s.1.2.1.3c2.9 7 5.7 13.6 6.2 15.1.1.3.4.6.7.7.8.2 2.4.6 4.5.4.2-.5.6-.9 1-1.1-.4-1.5-1.4-4.5-3-8.6z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.1 89.4c.1.2.1.3.2.5-.1-.2-.2-.4-.2-.5z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90.7 88.4c.1.2.2.5.3.7-.1-.2-.2-.4-.3-.7z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.8 86.5c0 .1.1.2.1.3 0-.2 0-.3-.1-.3z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90 86.8c.2.5.4 1.1.7 1.6-.3-.6-.5-1.1-.7-1.6z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.4 90.2c0-.1-.1-.2-.1-.3 0 .1.1.2.1.3z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M91.4 90.2c0-.1-.1-.2-.1-.3 0 .1.1.2.1.3z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92 91.7c0-.1-.1-.2-.1-.3.1.1.1.2.1.3z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M92 91.7c0-.1-.1-.2-.1-.3.1.1.1.2.1.3z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.8 91.2c-.1-.1-.1-.3-.2-.4.1.1.2.2.2.4z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M91.8 91.2c-.1-.1-.1-.3-.2-.4.1.1.2.2.2.4z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M90.6 88.4s.1 0 0 0c.1 0 0 0 0 0z",
    style: {
      fill: '#003623'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M90.6 88.4s.1 0 0 0c.1 0 0 0 0 0z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M91 89.2c0 .1.1.1.1.2-.1-.1-.1-.2-.1-.2z",
    style: {
      fill: '#003623'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M91 89.2c0 .1.1.1.1.2-.1-.1-.1-.2-.1-.2z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M90 86.7z",
    style: {
      fill: '#003623'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M90 86.7z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.6 88.5c-.8-1.9-1.6-3.8-2.5-5.9-.2-.2-.4-.3-.6-.5-.9 1-1.9 2.1-3.2 3.3-.5.5-1 .8-1.5 1 0 .1.1.2.1.3.2.5.4 1.1.7 1.6v.1c.1.2.2.5.3.7 0 .1.1.1.1.2.1.2.1.3.2.5 0 .1.1.2.1.3.1.2.2.4.2.6.1.1.1.3.2.4 0 .1.1.1.1.2s.1.2.1.3c3.5-.6 5.1-1.8 5.7-3.1z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M97.6 88.5c-.8-1.9-1.6-3.8-2.5-5.9-.2-.2-.4-.3-.6-.5-.9 1-1.9 2.1-3.2 3.3-.5.5-1 .8-1.5 1 0 .1.1.2.1.3.2.5.4 1.1.7 1.6v.1c.1.2.2.5.3.7 0 .1.1.1.1.2.1.2.1.3.2.5 0 .1.1.2.1.3.1.2.2.4.2.6.1.1.1.3.2.4 0 .1.1.1.1.2s.1.2.1.3c3.5-.6 5.1-1.8 5.7-3.1z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.8 88.1c0-.1.1-.2.1-.3-.1.1-.1.2-.1.3z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M115.8 88.1c0-.1.1-.2.1-.3-.1.1-.1.2-.1.3z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M115.8 87.8c.1-.5.3-1.4.5-2.3-.2.8-.3 1.5-.5 2.3z",
    style: {
      fill: '#003623'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M115.8 87.8c.1-.5.3-1.4.5-2.3-.2.8-.3 1.5-.5 2.3z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M109.2 88.9c.2-1.2.5-2.5.7-3.9-.3 1.7-.6 3.1-.7 3.9-.1 0-.1 0 0 0z",
    style: {
      fill: '#003623'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M109.2 88.9c.2-1.2.5-2.5.7-3.9-.3 1.7-.6 3.1-.7 3.9-.1 0-.1 0 0 0z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.3 85.5c.1-.7.3-1.5.4-2.1-1.7 2.5-4 2.8-6.2-1.3l-.6 3c-.3 1.3-.5 2.6-.7 3.9 3.3.7 5.5.4 6.6-.8 0-.1 0-.2.1-.3.1-.9.2-1.6.4-2.4z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M116.3 85.5c.1-.7.3-1.5.4-2.1-1.7 2.5-4 2.8-6.2-1.3l-.6 3c-.3 1.3-.5 2.6-.7 3.9 3.3.7 5.5.4 6.6-.8 0-.1 0-.2.1-.3.1-.9.2-1.6.4-2.4z",
    style: {
      opacity: 0.54,
      fill: '#006028',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M107.3 106.8a2.36 2.36 0 0 0 0 0z",
    style: {
      fill: '#D4DFD4'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.1 107.7z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M108.1 107.7z",
    style: {
      opacity: 0.65,
      fill: '#FFFFFF',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M107.3 106.8z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M107.3 106.8z",
    style: {
      opacity: 0.65,
      fill: '#FFFFFF',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.5 106.7c.3-.2.7-.3 1.1-.4-.4.1-.7.2-1.1.4z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M104.5 106.7c.3-.2.7-.3 1.1-.4-.4.1-.7.2-1.1.4z",
    style: {
      opacity: 0.4,
      fill: '#14823C',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M104.5 106.7c-.4.3-.8.7-1 1.1.3-.4.6-.8 1-1.1z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M104.5 106.7c-.4.3-.8.7-1 1.1.3-.4.6-.8 1-1.1z",
    style: {
      opacity: 0.4,
      fill: '#14823C',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "m98.6 75.5-1.2-1.3-4.7-5.4-.6-.8-.6-.7-4.1-4.7-.7-.8c-.2-.3-.5-.4-.8-.6-.3-.1-.6-.2-.8-.1-2.5.4-5 1.7-7.2 2.9-.9.5-1.4.9-1.5 2v.1c-.1.9.1 1.7.2 2.6.6 3.9 1.9 7.9 3.9 11.4.3.6.7 1.2 1.1 1.8v.1c.7 1 1.5 1.8 2.4 2.6.4.3.7.6 1.1.9 1 .8 2.1 1.2 3.1 1.2.6 0 1.1-.1 1.7-.3.5-.2 1-.6 1.5-1 1.3-1.2 2.3-2.3 3.2-3.3l.3-.3.1-.1c3.5-4.2 3.6-6.1 3.6-6.2z",
    style: {
      fill: '#9AA69F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "m87.4 62.7 4.1 4.7-3.8-4.4-.3-.3z",
    style: {
      fill: '#CFD1CA'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M81.6 82.1c-5-7.8 8-12.4 11.2-13.3l-.7-.8-.6-.7-4.1-4.7-.7-.8c-.2-.3-.5-.4-.8-.6-.3-.1-.6-.2-.8-.1-2.5.4-5 1.7-7.2 2.9-.9.5-1.4.9-1.5 2v.1c-.1.9.1 1.7.2 2.6.6 3.9 1.9 7.9 3.9 11.4.3.8.7 1.4 1.1 2z",
    style: {
      fill: '#D4DFD4'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M108.1 74.6c-.1 0-.1 0 0 0 .6 2.9 1.3 5.1 2.1 6.7.1.3.2.5.4.8 2.1 4.1 4.5 3.8 6.2 1.3.3-.4.5-.9.8-1.4.4-.8.7-1.7 1-2.7-3.3 4.8-8.8-10.3-8.8-10.3 0-.2.1-.5.1-.7v-.1.1c-.1.8-.3 1.6-.5 2.4-.7 1.9-1.3 3.6-1.3 3.9z",
    style: {
      fill: '#9AA69F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M109.7 68.3c0 .2-.1.5-.1.7 0 0 5.5 15.1 8.8 10.3.5-1.9.8-4 .8-6.3 0-2.2-1-4.2-2.4-6-.2-.3-.4-.5-.7-.8-2.3-2.7-6.4-2.8-6.4-2.8s0 1-.1 2.7c.2.6.2 1.3.1 2.2 0-.1 0-.1 0 0z",
    style: {
      fill: '#D4DFD4'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.9 73.7c0-.1 0-.2.1-.3-.1.1-.1.2-.1.3z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.9 73.8c0 .1 0 .2-.1.3 0-.1 0-.2.1-.3z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.7 74.4c0 .1 0 .1 0 0 0 .1 0 .1 0 0z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66 72.9z",
    style: {
      fill: '#293F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.4 103.1c1.8-1.1 3.5-2.4 5.2-3.6 1.4 3.9 2.6 8 3.5 12.4 1 4.4 1.6 9.5 2.1 14 1.4 13.2 2 28.5 2.2 39.8 8.8-.4 18.4-1.4 28.1-2.8-1.9-18.4-5-30.1-8.5-52.1-2.5-15.7 1.1-22.9 4.9-26.2-1.4-1.2-2.7-2.8-3.5-4.4-2-3.5-3.3-7.5-3.9-11.4-.1-.9-.3-1.7-.2-2.6-.2-.1-.4-.2-.5-.4-4-2.6-7.8-4.4-12.6-4.4h-.3c2.6.3 4 1.8 2.5 5.7 0 .1-.1.2-.1.3-1.6 3.7-4.8 7.8-6.9 10.3-5 6-11.9 10.8-18.2 15.4-2.9 2.1-6 4-9.1 5.7 2.6-5.4 6.7-19.6 8.8-27.4.7-2.5 1.2-4.4 1.4-5l1.5-4.8.3-1.2c2.7-9 4.7-17 5.6-22.1-2.1 7.2-6.3 9.6-10 8.7-.2 0-.3-.1-.5-.2-1.5 4.3-2.2 8.4-3.8 12.6-2.4 6.5-4.7 15-7.8 22-.2.4-.4.8-.5 1.2-2 4.5-3.9 9-6.2 13.3-2.2 4.2-4.7 8.6-8.7 11.4-.7.5-1.8 1.2-2.6 1.3-2.1.3-3.3-2-3.9-4.1-.3-1-.5-2-.6-2.7v-.2c0 3.1 0 6.2.9 9.2.3.9.7 1.9 1.1 2.9.5 1 1.6 2.8 2.9 3.4 3.9 1.6 7.9.4 11.7-.8 8.1-2.6 18.6-8.7 25.7-13.2zM66 72.9zm-.3 1.6zm.1-.4c0-.1 0-.2.1-.3-.1.1-.1.2-.1.3zm.1-.4c0-.1 0-.2.1-.3-.1.1-.1.2-.1.3z",
    style: {
      fill: '#0C2026'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.4 32.7s-2.2-.5-5.1-2.5c-.1 0-.1-.1-.2-.1h.1c-.2-.2-.4-.3-.7-.5-1.3-.9-1.9-2.2-2.2-3.5-.4-2.1.3-4.3 1.7-5.9l-.2.2c-1.1 1.3-5.5 6.2-10.1 12.9-.1.2-.2.4-.2.6v.2c-.1.9-.2 2.2-.1 2.9.1 5.4 2.6 9 5.7 10.2.1 0 .2.1.3.1h.2c3.8.9 8-1.5 10.2-8.8.1-.4.2-.7.3-1.1.1-.6 1-2.6 1.3-4.6-.4.1-.7 0-1-.1z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.6 30.3c0 .1-.1.1-.1.1s-2 9-5.4 16.8c.2.1.4.2.7.2.9.2 2.1.1 2.8 0 1-.3 2-.7 2.8-1.3 2.3-1.8 3.6-4.6 4.5-7.3.7-2.1 1.5-4.1 2.3-6.2-1.4.1-2.8 0-4.2-.4-.5-.2-1-.4-1.5-.7-.3-.2-1.9-.9-1.9-1.2z",
    style: {
      fill: '#1F5835'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M62.8 26.8z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M61.8 29.3s0-.1 0 0c0-.1 0 0 0 0z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M62 29.4s-.1 0-.1-.1l.1.1z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M61.6 29z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M61.9 29.4c0-.1-.1-.1 0 0-.1-.1 0-.1 0 0z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M97.3 40.5c-.1 1.2 5.3.7 5.4.1 0-.5-5.3-1-5.4-.1z",
    style: {
      fill: '#F6B694'
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M90.2 28.5c-.3-2.2-.9-5-2.6-6.3-.4-.7-.8-1.3-1.3-1.9l.7 1.4c-.8-.6-1.7-1.1-2.7-1.5-2.7-1-5.6-.6-7.6 1.5-6.6 6.8 2.1 17.8 2.1 17.8s3.1 4.4 5 5.3c3.7 1.9 5.1-4.3 5.7-6.8.7-2.7 1.1-5.5.9-8.4-.1-.2-.2-.6-.2-1.1z",
    style: {
      fill: '#2C0007'
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M113.1 3.3c-.3-.2-.6.1-.4.4 4.4 7.3-13.1 5-29.3 8.9-10.2 2.5-11.1 7.5-10.2 11.2.9-.3 1.8-.2 2.5.4.3.2.6.4.9.5 1 .1 2 .1 3 .2.4 0 .9.1 1.3.2h2.4c4.5-.1 11.1 0 20.1-.6 20.2-1.3 17.6-15.7 9.7-21.2z",
    style: {
      fill: '#521C2A'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M105.1 24.3c18.4-1.9 15.7-15.7 8.1-21-.3-.2-.6.1-.4.4 4.4 7.3-13.1 5-29.3 8.9-3.9.9-6.4 2.2-8 3.7 2.6-1.9 6.7-1.6 20.1.4s16-2.4 16.5-4.8c.1-.5.8-.6 1-.2.5.9 1 2.3 1.1 4.7.1 6-6.2 7.5-9.1 7.9z",
    style: {
      fill: '#81363F'
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M86.9 25c-.2 0-6.9-.3-10.5-2-2.8-1.3-2.9-4.1-2.6-4.7-2.7 4.6 1.4 9.8 1.4 9.8-.5-3 2.9-3 11.7-3.1z",
    style: {
      fill: '#2C0007'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M86.4 43.4c-.6-1.4-1.4-2.8-2.7-3.5-1.8-1-4-1.1-5.9-.4-1.4.5-2.5 1.5-3.3 3 0 0-.1.1-.1.2-3 7.1 2.5 13.6 8.3 14.7.7.2 1.4.2 2.1.1.2 0 .7-1.6.8-1.8.2-.6.5-1.2.7-1.9.4-1.4.8-2.8.9-4.2.2-1.3.3-2.9 0-4.1-.3-.7-.6-1.4-.8-2.1z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.2 43c.1 1.2-.1 1.9-1.1 2.2-1.1.4-2.8-.1-3.9-2.4-.8-1.6-3.1-2.2-4.7-1.8-1.2.2-2.1 1-2.6 2.1-.4 1-.6 2.1-.6 3.2-.1 2.2.6 4.3 1.8 6.1 1.2 1.7 2.9 3.2 4.8 4 .8.4 1.8.7 2.7.8.8.2 1.9.3 2.6.2 2.2-4.7 3.8-10.1 1-14.4z",
    style: {
      fill: '#81363F'
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M85.1 14.7c-.1-.2-.2-.4-.4-.6l-.5-.5c0-.1-.1-.1-.1-.2-.5-.5-1.1-1-1.6-1.4C77 7.8 70.6 7.9 67.7 8.3c-6.5.9-20.6 9.3-20.6 9.3s-.4.2-1 .6c-.7.4-1.5.9-2.1 1.3-.6.3-1.1.8-1.6 1.2-1.4 1.5-2.1 3.5-1.7 5.7.3 1.3.9 2.5 2.2 3.4.2.2.4.3.7.5h-.1c.1 0 .1.1.2.1 2.8 1.9 4.9 2.5 4.9 2.5.3.1.6.1.9.2 3.7.6 7-1.6 13.1-6.1-1.1 1.1-1.4 1.8-1.2 2.2 0 .1.1.1.1.2h.1s.1 0 .1.1c0 0 .1 0 .1.1.1 0 .3.1.4.1h2c.3 0 .5-.1.8-.2h.2c.2 0 .4-.1.5-.1.8-.2 1.6-.5 2.3-.8 1.4-.6 2.4-1.3 2.5-1.9V26.4c.8-.4 1.5-.8 2.1-1.2 0 0 0 .1-.1.1.1-.1.3-.2.4-.3 1.2-1.1 1.6-2.5.4-4.2l.2-.2c.4-.4.7-.8.9-1.1 0 0 0-.1.1-.1l.1-.1c.9-1.3.8-2.2.1-2.8-.9-.8-2.7-1.3-4.6-1.8-.1 0-.2-.1-.4-.1.2-.4.6-.7 1.1-1 1.8-.3 3.4-.3 4.7.4 1.6.9 3.3 1.6 5 2 1.3.3 2.9.7 4.1.3.5-.4.9-.8.5-1.6z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M70.7 26.5c0-.1 0-.1 0 0-.2-1-1.1-2.5-4.7-4.2-2.3-.9-1.2 1.2.1 2 1.2.8 4.9 1.8 2.1 4 1.3-.5 2.4-1.2 2.5-1.8z",
    style: {
      fill: '#F6B694'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M48.6 32.8c.3.1.6.2.9.2 3.8.6 7.1-1.6 13.3-6.2-1.1 1.1-1.4 1.8-1.2 2.2 0 .1.1.1.1.2h.1s.1 0 .1.1c0 0 .1 0 .1.1.8.3 2.3.1 3.9-.3 4.5-2.4-1.4-3.5-3.9-2.4-2.6 1.2-4.6 1.7-4.6 1.7-4.7 1.3-11.2 2.8-13.9 1.9h-.1c.1 0 .1.1.2.1 2.8 1.9 5 2.4 5 2.4zm14.2-6z",
    style: {
      fill: '#81363F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M69.6 14.7c.2-.4.5-.9 1.1-1 1.6-.5 3.2-.5 4.7.1 1.6.9 3.3 1.6 5.1 2 1.3.3 2.9.8 4.2.4-.9-.2-4.7-1.1-8.5-3.1s-9.7-1.1-9.4 1h.5c1 .2 1.2.5 2.3.6z",
    style: {
      fill: '#81363F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M74.8 16.1c-.9-.8-2.7-1.3-4.7-1.8-.1 0-.2-.1-.4-.1l-2.2-.2H67c-.9 0-2.1.2.4 1.9 3.5 2.5 7 .8 7.1 3.2 0-.1.1-.1.1-.2.9-1.3.9-2.1.2-2.8z",
    style: {
      fill: '#F6B694'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M73 24.8c1.2-1.1 1.6-2.5.4-4.3-1.9-2.6-6.7-2.9-6.7-2.9-.5-.4-5.9 2 1.3 3.4 6.5 1.3 5 3.6 4.7 4.1 0 0 0 .1-.1.1l.4-.4z",
    style: {
      fill: '#F6B694'
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M70.5 8.1c3.3 0 7.9.7 12.1 3.9.5.4 1.1.9 1.6 1.4 0 .1.1.1.1.2l.5.5.1.1c-.8.3-5.3-2.6-10.6-3.5-4.8-.8-10.5 1.3-11.7 2.9 2.3.9 1.4 2 .4 3-1 1.1 1.7 3.4-.4 4.5 0 0-.1.1-.2.1-.8.5-1.7.9-2.7 1-5.5.7-15.9 1.6-15.9-1.1 0-.7.7-1.7 2.4-2.9.6-.4 1-.6 1-.6s11.7-7 18.9-9c.1 0 .3-.1.4-.1.5-.1.9-.2 1.3-.2.7-.1 1.6-.2 2.7-.2z",
    style: {
      fill: '#F6B694'
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M96.3 28.2c-.1 0-.2 0-.2-.1-.1-.1 0-.3.1-.3 2.3-1.5 4.5-2.7 7.6-1.1.7.4 1.2.5 2.1.5.5-.1 1-.4 1.5-.7.5-.4 1.1-.7 1.9-.8 1.1-.1 2.4.4 3 1.1.1.1.1.2 0 .3-.1.1-.3.1-.3 0-.5-.6-1.6-1-2.5-.9-.6.1-1.1.4-1.7.7-.5.3-1 .7-1.7.7-1 .1-1.7-.1-2.4-.5-2.5-1.3-4.4-.7-7 1-.3 0-.3.1-.4.1z",
    style: {
      fill: '#A34B56'
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M195.6 44.3c-.1-.6-1-.6-2.6.2-2.8 1.3-10.2 6.8-10.7 7.1l.4-.4c1.8-1.9 9.2-9.4 9.9-11.1.4-1 .3-1.5-.3-1.6-.5-.1-1.3.2-2.2.9-1.8 1.4-10.8 8.8-10.8 8.8s6.8-9 7.2-10.3c.1-.4.1-.7-.1-1l-.2-.2c-.6-.4-1.8-.2-3.5 1.4-2.3 2.2-6.3 7.6-7.4 8.4 0 0 .1-.1.2-.4.6-1.5 2.6-6.6 3.1-8.1.2-.6.1-1-.2-1.1-.5-.2-1.6.4-2.4 1.7-1.3 2-5.2 7.1-6 8.1-.8 1-.8 1.3-3.4 2-2.7.7-11 1.9-13.6 4l.2-.1c-2.1 1.3-3.3 3.4-3.4 5.3 0 1.4.6 2.7 2 3.5.6.3 1.3.6 2.1.7 5.6.9 18.8-.4 24.9-3.1 6.2-2.7 14.8-10.8 16.1-12.9.6-.8.8-1.4.7-1.8z",
    style: {
      fill: '#CA7B6C'
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M195.6 44.3c.1.4-.1 1-.6 1.9-1.3 2.1-9.9 10.2-16.1 12.9-6.2 2.7-19.3 4-24.9 3.1-.8-.1-1.5-.4-2.1-.7-.1-2.2 4.5-2.8 8.4-3 4.8-.3 14.2 1.8 18 .2 3.7-1.6 12-8.5 13.7-10.1 1.6-1.7 3.2-2.7 3.6-4.3z",
    style: {
      fill: '#81363F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M192.4 38.6c.5.1.7.6.3 1.6-.7 1.7-8.1 9.2-9.9 11.1l-.4.4c-1.9 1.9-4.3 1.9-2.8.4 1.5-1.4 5.4-4.5 8.1-7.2 2.1-2.3 4.3-4.6 4.7-6.3z",
    style: {
      fill: '#81363F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M186.5 36.9c.2.2.2.6.1 1-.5 1.3-7.2 10.3-7.2 10.3-2.3 2.7-4.1 3.2-2.7 1.5 1.3-1.6 7.9-9.6 9.8-12.8z",
    style: {
      fill: '#81363F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M182.9 38.2c1.7-1.6 2.9-1.8 3.5-1.4-1 0-1.7.6-2.5 1.4-1 1-5.3 6.2-6.3 7.9-1.1 1.7-3.2 2.3-2 .1h.1l-.2.4c1.1-.8 5.1-6.2 7.4-8.4z",
    style: {
      fill: '#F6B694'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M176.1 38.6c.9-1.3 1.9-1.9 2.4-1.7-1 .3-1.6 1-2.7 3.1-1.4 2.6-3.8 5.9-4.9 7.7-1.1 1.8-1.8 2.3-4.6 3.3s-6.2 1.4-9.3 3.6c-2.5 1.7-5.2 3.9-7.1 3.4 0-1.9 1.2-4 3.4-5.3l-.2.1c2.7-2.1 11-3.3 13.6-4 2.7-.7 2.7-1 3.4-2 .8-1.1 4.6-6.2 6-8.2z",
    style: {
      fill: '#F6B694'
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M110.8 134.3c-1.9-2-3-3-5.9-3.3-.6-.1-1.6 0-1.9-.3-.2-.1 0 .4-.4-.2-.3-.4-.1-1.8-.1-2.5 0-2.3 0-4.5-.7-6.6-.4-1.3-1-2.7-1.7-3.9 0-.2-.1-.4-.1-.5-.4-1-.9-1.9-1.4-2.8-.1-.3-.3-.6-.3-1 0 .1 0 .1 0 0 .3-.8.2-1.8-.5-2.5.3-.4.7-.7 1.2-.7l4.5-.4c-.1-.2-.1-.4-.1-.6-.1-1.5 1-2.8 2.6-2.9 1.5-.1 2.9 1 3 2.5 0 .2 0 .5-.1.6l4.5-.4c.9-.1 1.7.5 1.7 1.5l1.9 22.3c0 .8-.5 1.6-1.5 1.6l-4.6.4c.1 0 0-.2-.1-.3z",
    style: {
      fill: '#D4DFD4'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m111.4 134.6-10.2.8c-.9.1-1.7-.5-1.7-1.5l-1.9-22.3c0-.5.1-.8.4-1.1l13.4 24.1z",
    style: {
      fill: '#1E9A48'
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M113.4 108.9c.9-.1 1.7.5 1.7 1.5l1.7 19.5c-2-10.3-9.7-20.4-9.7-20.4l6.3-.6z",
    style: {
      fill: '#FFFFFF'
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M106.8 109.7c1.6-.7 1.2-2.3.5-2.9-.5-.5-1.2-.5-1.5-.5h.1c1.5-.1 2.9 1 3 2.5 0 .2 0 .5-.1.6-.9 2.1-2.9.8-2 .3z",
    style: {
      fill: '#FFFFFF'
    }
  })));
};

var SvgActionSuccess = function SvgActionSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 200 166",
    style: {
      enableBackground: 'new 0 0 200 166'
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, '.st0{fill:#D2DFBD;}\n\t.st1{fill:#823740;}\n\t.st2{fill:#DC8A84;}\n\t.st3{fill:#AF5760;}\n\t.st4{fill:#785559;}\n\t.st5{fill:#462C30;}\n\t.st6{fill:#250E12;}\n\t.st7{fill:#1B9B48;}\n\t.st8{fill:#3B545C;}\n\t.st9{fill:#283F46;}\n\t.st10{fill:#BFD0BC;}\n\t.st11{fill:#9EAD9D;}\n\t.st12{fill:#F8C9B5;}\n\t.st13{fill:#3C131C;}\n\t.st14{fill:#FFFFFF;}\n\t.st15{fill:#782531;}\n\t.st16{fill:#F7F0F6;}\n\t.st17{fill:#641A26;}\n\t.st18{fill:none;}\n\t.st19{fill:#24786F;}\n\t.st20{fill:#1E9A48;}\n\t.st21{fill:#D4DFD4;}\n\t.st22{opacity:0.65;fill:#FFFFFF;enable-background:new    ;}\n\t.st23{fill:#7EC187;}\n\t.st24{fill:#FAEA91;}\n\t.st25{fill:#F5B694;}\n\t.st26{fill:#FDD3B5;}\n\t.st27{fill:#B26E67;}\n\t.st28{fill:#CC7B6D;}\n\t.st29{fill:#F8B795;}\n\t.st30{fill:#521C2A;}\n\t.st31{fill:#833640;}\n\t.st32{fill:#EFA389;}'), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.6 84.9c-1.1-1.7-2.3-3.5-3.6-5.4l-.1-.1c-5.7-8.2-13.9-18.9-31.1-41.8-21.2-28.2-52.6-18.8-65.7-4.9C68.5 46.2 46.9 71 33.9 87.5c-7.7 9.7-11.8 18-11.3 26.1.2 4.3 1.8 8.6 4.8 13 5.4 7.8 11.6 17.2 23.9 29.3 14.7 14.4 33.9 11.5 52.8 2.2 13.8-6.8 33.5-14.1 63.9-31.5 30.4-17.3 19.6-32.5 13.6-41.7z",
    style: {
      fill: '#D2DFBD'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.2 72.2c-20.5 5.6-18.6-28.4-27.5-45.3 1.6 5.9 2.8 14 4.7 21.6 1.9 7.4 4.5 14.4 5.2 16.5.2.4.3.8.6 1.2 1 1.8 4 7.4 6.8 11.1 5.9 7.6 12.7 12.2 15.2 10.3 2.3-1.8 0-8.4-5-15.4z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.1 72.2c.1 0 .1 0 0 0-.4-.6.2-1.7-.3-2.3-2.4-3.1-6.6-8.3-6.6-8.3s-1.3-6.6-4.5-15.5-6.9-17.9-9.3-22.9c-.7-1.4-1.2-1.7-1.7-1.7 4.8 13 10.5 26.1 13.1 40.2 3.4 3.5 5.9 7 9.3 10.5z",
    style: {
      fill: '#DC8A84'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m118.9 61.7.3 1.5c-.1-.4-.2-.9-.3-1.5-.3-.4-.7-.7-1-1.1.4.4.7.8 1 1.1-2.6-14.1-8.3-27.2-13.1-40.2-.7.1-1.4.9-2.2 1.1-1.5.3-4.9-1.8-3.5 2.4.2.6.4 1.2.5 1.9 8.9 16.9 7 50.9 27.4 45.3-3.3-3.5-5.8-7-9.1-10.5z",
    style: {
      fill: '#AF5760'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162.8 36.5c-.1 0-.1-.1-.2-.1-4.5-1.4-7.3 1.5-7.2 2.8.1 1 .1 1.6.3 2.2v-.3c1.7-2.7 4.4-4.4 7.1-4.6z",
    style: {
      fill: '#785559'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179 67.2c-.4-.3-.8-.5-.9-1-.3-.9.6-2.1.7-3.1.1-1.5-.4-3.1-1.5-4.2-.6-.6-2.1-1.1-2.5-1.8-.4-.8.2-1.9.2-2.7.1-.8 0-1.6-.3-2.4-.4-1.2-1.1-2.4-2.1-3.3-1-.9-2.4-1.1-3.4-2-1.7-1.5-.9-4.1-1.7-5.9-.8-1.8-2.3-3.4-4.2-4-2.8-.9-6.2 2.1-7.6 4.3v.3c.1.6.4 1.1.9 1.9.7 1.3 1.9 1.8 3.1 1.7-.3 1.4-.5 2.9-.7 4.3-.3 3.1-.3 6.3.6 9.3.9 2.9-4.2 6.9-2 8.7 2 1.6-1 8.5 1 10.1 9.5 7.2 5.7 12.4 2.8 6-.8-1.9-3.4-2.2-4.8-1.1-1.7 1.3-1.3 2.8-1.4 4.6-.1 2.1-.8 3.9-.1 6 .6 1.8 2.3 3.4 4.1 3.2 1.3-.1 3.1-2.1 4.2-1.8.5.1 1.3 1.1 1.8 1.5.7.4 1.4.6 2.1.7 2.2.2 4.5-.9 5.7-2.7 1.1-1.6.6-3.8 2.3-5.1 1.9-1.5 4.6-2.3 5.7-4.6.7-1.4.7-3.1.1-4.6-.3-.6-.6-1.2-.9-1.9-.6-1.6 1.1-3.5 1.1-5.3.1-1.9-.7-3.6-2.2-4.7.2-.2 0-.3-.1-.4z",
    style: {
      fill: '#462C30'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M178.4 78c-.9-2.8 1-5.4-.9-8-1.3-1.9-3.3-2.8-5-4.3-1.8-1.7-1.7-3.9-1.4-6.2.4-2.9-.2-5.7-2.1-8-2.1-2.6-4.8-2.8-7.5-4.2-2.5-1.3-4.4-3.3-6.1-5.4-.7-.8-1.4-1.2-2.1-1.2.2 1.9.2 2.2 1.1 3.8.7 1.3 1.9 1.8 3.1 1.7-.3 1.4-.5 2.9-.7 4.3-.3 3.1-.3 6.3.6 9.3.9 2.9-4.2 6.9-2 8.7 2 1.6-1 8.5 1 10.1 9.5 7.2 5.7 12.4 2.8 6-.8-1.9-3.4-2.2-4.8-1.1-1.7 1.3-1.8 3.6-1 5.5 1 2.3 2.9 4.1 5.4 4.9 1.2.4 2.4.3 3.6.6 1.6.4 3 1.1 4.7 1.2 1.9.1 4-.6 5.1-2.2 1.1-1.5 1.1-3.6 2.2-5.1 1.2-1.6 3.5-2.1 4.6-3.8 1.7-2.4 0-4.4-.6-6.6z",
    style: {
      fill: '#250E12'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M152.4 42.3c1-2.2 3-2.9 6.1-2.2 4.3.9 5.7 6.3 3.2 9.5-2.5 3.1-7.2-2.5-7.2-2.5l-2.1-4.8z",
    style: {
      fill: '#1B9B48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.7 71.1c-.2-.4-.5-.9-.7-1.3-.5-.8-1.7-1.5-2-2.4 0-.1-.1-.2-.1-.3V67c-.1-.2-.2-.3-.3-.5-.2-.4-.5-.7-.7-1-.6-.9-1-1.9-1-3 0-.3.1-.6.2-.8-.1-2.6.6-5.1.8-7.6.1-1.8.2-3.7.2-5.5 0-2-.3-4.1-1.7-5.7-1.4-1.6-3.1-2.9-5-3.8h-.1c-.6-.3-1.2-.5-1.7-.7-.6-.2-1.3-.4-1.9-.6-8.4-2-16.7 2.9-18.7 11-1.6 6.6 5.3 9.8 8.4 15.1 3.2 5.6 2.5 13.1 4.4 19.3.7 2.5 1.4 5.1 2.8 7.3 2.5 4 8.9 5.8 12.8 2.6 3.5-2.9 5.8-7.2 6.3-11.7.3-2.6-.1-5.3-1-7.9-.2-.9-.6-1.6-1-2.4z",
    style: {
      fill: '#462C30'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M166.1 71.7c-3.1-4.7 1.8 1 2-1.1 0-7.3-4-14.1-6-21-.4 2.8-.4 4.3-1.8 6.7.8-3 .6-6.1-.4-9-1.7 1.2-2 1.7-4 .9-1.7-.7-3.2-2-4.5-3.3-8.4-8.3-8.3 24.9-4.6 30.3 1.2 1.7-.2 7.1 4 11.1 10 4.7 12.8-.7 18.3.6 5.1 1.3 5.8-1.7-3-15.2z",
    style: {
      fill: '#250E12'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M188.9 21.6c-.6-.2-1.3-.7-2-.9-.9-.3-1.9-.1-2.6 2.1-1.9 6.1-5.2 13.7-9 22-3.3 7.3-4.9 14.1-4.9 14.1s-3.2 4-5.7 7.4l-.6.9c-5.6 7.8-6.1 14.8-3.6 16.5 0 0 .1 0 .2.1 17-16.9 23.8-39.2 30-61.6-.5-.4-1.2-.4-1.8-.6z",
    style: {
      fill: '#AF5760'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.6 59.8c4.3-13.9 9.4-24.7 15.3-39.1-.9-.3-1.9-.1-2.6 2.1-1.9 6.1-5.2 13.7-9 22-3.3 7.3-4.9 14.1-4.9 14.1s-3.2 4-5.7 7.4c2.1-2.5 4.1-4.9 6.9-6.5z",
    style: {
      fill: '#DC8A84'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.7 22.1c-6.1 22.4-13 44.7-30 61.6 2.7 1.4 8.9-3.6 14.2-11.4 2.8-4.2 4.8-8.1 6.1-11 1.4-3.2 2.9-7.4 4.9-13.4 2.9-8.6 5.2-18.1 5.5-22.6.2-1.9-.1-2.8-.7-3.2z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M173.1 79.9c-1-1.7-2-3.3-3-4.8-2-2.9-4.2-5.6-6.8-8.1l-11 11.6-15.3.9-9-11.2c-2.3 3-4.4 6.2-6.2 9.5-.9 1.7-1.8 3.4-2.5 5.1l9 10.1.3.3s-3.9 5.7-2.1 12c.4 1.4 1.3 2.8 2.2 3.9 1.3 1.5 1.9 3.5 1.6 5.5-.9 7-3 23.3-3.9 33.2 10.5-4.8 23.1-10.9 38.7-19.6-1.6-8.2-2.7-21.4 1.6-39.1.1-.3 4-5.8 6.4-9.3z",
    style: {
      fill: '#3B545C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M123.3 79.6c7.6 8.8 6.5 8.5 4.9 13.4l-9-10.1c.8-1.7 1.6-3.4 2.5-5.1.5.6 1.1 1.2 1.6 1.8z",
    style: {
      fill: '#283F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M173.1 79.9c-1-1.7-2-3.3-3-4.8-2.8 4.8-4.2 7.6-7.9 11.5-5.2 5.4-3.3 11-6.3 16.2-3 5.2-14.3 5.8-11 11.1 1.5 2.4 3.9 2.7 5.7 4.5 2.3 2.3 1.9 5.6 1.7 8.6-.3 3.2-1 6.3-2.1 9.3 4.6-2.4 9.6-5.1 14.9-8.1-1.6-8.2-2.7-21.4 1.6-39.1.1-.2 4-5.7 6.4-9.2z",
    style: {
      fill: '#283F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M174.7 76.7c-.9-1.8-1.9-3.5-3-5-1.8-2.5-3.9-4.8-6.3-6.8l-2 2.1c2.5 2.5 4.7 5.1 6.7 8 1.1 1.6 2.1 3.2 3.1 4.9 1.1-1.5 1.9-2.7 1.9-2.7l-.4-.5z",
    style: {
      fill: '#BFD0BC'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m165.4 64.9-2 2.1c2.5 2.5 4.7 5.1 6.7 8 .6-1.1 1.1-2.3 1.7-3.4-1.9-2.4-4-4.7-6.4-6.7z",
    style: {
      fill: '#BFD0BC'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m175 77.3-.3-.6c-.9-1.8-1.9-3.5-3-5-.6 1.1-1.1 2.3-1.7 3.4 1.1 1.6 2.1 3.2 3.1 4.9 1.1-1.6 1.9-2.7 1.9-2.7z",
    style: {
      fill: '#9EAD9D'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143.4 62.2h1.1c.5 0 1 0 1.6.1.4 0 .8.1 1.1.2.3.1.4.4 0 .6-.4.1-.9.1-1.3.1-.5 0-.9 0-1.4-.1-.5 0-.9-.1-1.3-.1s-.8 0-1.1-.2c-.1-.1 0-.3.2-.3.3-.1.6-.1.9-.1h.1c0-.2.1-.2.1-.2z",
    style: {
      fill: '#F8C9B5'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M142.2 59.9c-.1.4 0 .7 0 1.1 0 .3.1.5.2.6.1.1.3-.1.4-.4.1-.2.2-.5.2-.7.3-1.1.5-2.1.7-3.2.1-.5.2-.9.2-1.4 0-.3 0-.5-.1-.6-.1-.2-.3-.1-.4.1-.1.1-.1.2-.2.3-.1.3-.2.5-.3.8-.3 1-.4 2.2-.7 3.4z",
    style: {
      fill: '#3C131C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M135.2 54.8c-.3.8-.6 1.7-.7 2.5-.1.7-.3 1.4-.4 2.1 0 .3 0 .6.1.8.2 0 .4-.2.5-.5s.2-.7.3-1c.3-1.2.5-2.3.8-3.5 0-.2.1-.4.1-.6.3-1.4-.5-.6-.7.2z",
    style: {
      fill: '#3C131C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M144.6 65.3s-.1 3.6-3.1 3.7c-3.4.1-2.7-3.5-2.7-3.5",
    style: {
      fill: '#FFFFFF'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M140.7 69.3c.3.1.6.1.9.1 2.6-.1 3.4-2.7 3.4-4.1 0-.2-.2-.4-.4-.4s-.4.2-.4.4c0 .1-.2 3.3-2.7 3.4-.8 0-1.4-.2-1.8-.6-.8-.9-.5-2.5-.5-2.5 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3 0 .1-.3 1.9.7 3.1.3.3.9.6 1.5.7z",
    style: {
      fill: '#782531'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M136.4 65.5h8.2c.2 0 .4-.2.4-.4s-.2-.4-.4-.4l-7.8.1.1-4.7 1 1.1c.1.1.4.2.5 0 .1-.1.2-.4 0-.5l-1.6-1.8c-.1-.1-.3-.1-.4-.1-.1.1-.2.2-.2.3l-.1 6c0 .1 0 .2.1.3s.1.1.2.1z",
    style: {
      fill: '#782531'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.2 38.3c.7-.3 1.3-.5 2.4-.1-.6-.2-1.2-.4-1.9-.6-8.4-2-16.7 2.9-18.7 11-.5 2.1-.5 4.3-.1 6.3 4.5-2.5 8.9-10.1 8.5-12.8-.4-2.5 3.3-3 5-3.2 1.2-.2 2.6 0 3.7-.3.5 0 .8-.1 1.1-.3z",
    style: {
      fill: '#785559'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M159 59.1c.2-.6 1 .5 1-.2-.3-3.5-3.4-4.1-4.7-3.7-.7-6.5-3.4-12.7-10.7-13.2 0 0-1.4-.2-3.3.2l-.1.1c-2.2 1.5-4.5 2.7-5.9 5.1-1.3 2.3-1.8 5.1-2.1 7.7-.5 5-1.6 11.6 3.5 14.7l.3.3c.1 0 .1.1.2.1.1.1.2.1.3.2.1 0 .1 0 .2.1.6.2 2.5.8 3.6.8.3 1.9.4 3.1.3 4.4-.1 1-.7 1.9-1.6 2.4-.5.2-.9.5-1 .9l.9 3.6 2.3 3.4c1 1.3 2.9 1.5 4.2.4l3.7-3.3c1.5-1.8.8-3.9 2.8-5.2.4-.3.9-.5 1.3-.7-.1.1-1.6-4.1-1.6-7.6 0-1.3.2-2.6.5-3.9.3-1.2 1-2.3 1-3.5 1.4 0 2.8-.4 3.8-1.3.5-.5.9-1.1 1.1-1.8z",
    style: {
      fill: '#AF5760'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153 65.6c-1.4 7.1 1.1 11.9 1.1 11.9l-4.1 4.4-.5-2.2c-.8-3.5-3-6.6-6.2-8.3l.2-.3s4.4.1 7.2-2.9c1.4-1.4 2.3-2.6 2.3-2.6z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M145.9 55.1c0 .3 0 .7.1 1 0 .3.1.5.3.5s.3-.1.4-.4c.1-.2.1-.5.1-.7.1-1 .3-2.1.4-3.1.1-.5.1-.9.1-1.4 0-.2-.1-.4-.2-.6-.2-.1-.3 0-.5.1-.1.1-.1.2-.2.3-.1.3-.2.5-.2.8-.2 1.2-.2 2.4-.3 3.5z",
    style: {
      fill: '#3C131C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M147.4 61.2s.3 4-3 4.1c-3.7.1-3.4-3.6-3.4-3.6",
    style: {
      fill: '#F7F0F6'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M143.2 65.6c-.6-.2-1.2-.4-1.6-.9-1.1-1.2-1-3-1-3.1 0-.2.2-.4.4-.4s.4.2.4.4c0 0-.1 1.5.8 2.5.5.5 1.3.8 2.2.8.8 0 1.4-.3 1.8-.8.9-1.1.8-2.9.8-2.9 0-.2.1-.4.3-.4s.4.1.4.3c0 .1.2 2.1-1 3.4-.6.6-1.4 1-2.3 1-.4.2-.8.1-1.2.1z",
    style: {
      fill: '#641A26'
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 148.2,
    y1: 53.8,
    x2: 148.9,
    y2: 53.6,
    style: {
      fill: 'none'
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 148.1,
    y1: 54.5,
    x2: 149,
    y2: 54.7,
    style: {
      fill: 'none'
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.8 70.9c-5.7-1.5-5.3-12.1-3.5-19.9 1.4-6.2 4.5-7.6 6.2-8.7-3.1.5-7.6 2.5-9 9-2.7 12.2.9 18.2 6.3 19.6z",
    style: {
      fill: '#DC8A84'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M136.8 51.4c-.2.8-.4 1.6-.5 2.5-.1.7-.2 1.3-.2 2 0 .3.1.6.2.7.3 0 .4-.2.5-.6.1-.3.2-.6.2-1 .2-1.1.3-2.2.5-3.4v-.5c.3-1.3-.5-.5-.7.3z",
    style: {
      fill: '#3C131C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1 60.4c0-.7-.1-1.5-.5-2.1-.8-1.4-2.5-2.3-4.1-2.1 0-2.5-.5-5.1-1.5-7.5-.5-1.2-1.2-2.3-2-3.2-1-1.1-2.3-1.5-3.4-2.4 3.4 2.7 3.7 9.8 3.6 13.7-.2 4.9-2.1 10.8-5.9 14 .2-.2 3.2-.6 5.3-2.3 1.5-1.2 2.2-2 3.2-4.3 1.5.5 3.4 0 4.4-1.3.6-.7.9-1.6.9-2.5z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.4 56.9h.9c.4 0 .8 0 1.2.1.3 0 .6.1.9.2.3.1.3.4 0 .6-.3.1-.7.1-1 .1-.4 0-.7 0-1.1-.1-.3 0-.7-.1-1-.1s-.7 0-.8-.3c-.1-.1 0-.3.1-.3.2-.1.5-.1.7-.1-.1-.1 0-.1.1-.1-.1 0-.1 0 0 0z",
    style: {
      fill: '#DC8A84'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M138.6 61.9c-.2 0-.3-.2-.3-.3l-.5-5c0-.1 0-.3.2-.4.1-.1.3-.1.4 0l1.8 1c.2.1.3.3.2.5s-.3.3-.5.2l-1.2-.6.4 4 8.4-.4c.2 0 .4.2.4.4s-.2.4-.4.4l-8.8.4c-.1-.1-.1-.1-.1-.2z",
    style: {
      fill: '#641A26'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M125.9 65.9c-2.4 3-4.5 6.2-6.3 9.7-.6 1.2-1.3 2.5-1.8 3.8l-.6 1.3 2 2.2c.8-1.7 1.6-3.4 2.5-5.1 1.8-3.3 3.9-6.5 6.2-9.5l-2-2.4z",
    style: {
      fill: '#BFD0BC'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m117.8 79.3-.6 1.3 2 2.2c.8-1.7 1.6-3.4 2.5-5.1-.7-.8-1.4-1.6-2.1-2.3-.6 1.4-1.3 2.6-1.8 3.9z",
    style: {
      fill: '#9EAD9D'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M128.6 100.1c.2-2.6.2-6-.1-6.7-.2.3-3.8 5.9-2.1 12 .4 1.4 1.3 2.8 2.2 3.9 1.3 1.5 1.9 3.5 1.6 5.5-.7 5.3-2.1 15.8-3 24.9 2-7.9 5.3-21.7 5.2-26.5-.2-5-4.3-5.8-3.8-13.1z",
    style: {
      fill: '#24786F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.3 18.2c-.2-1.9-1-3.7-2.9-3.9h-.1v-1.4c-.1-.6-.2-1.3-.4-1.9-.3-.7-1-1.3-2.1-1.5-.7-.1-1.4.3-1.6 1.1-.8-1.7-3.4-1.6-3.4.6-.5-.7-1.5-1.1-2.3-.8s-1.4 1.6-1.2 2.5c-1.4-.4-2.4.4-2.7 1.6-.2.7-.2 1.5.1 2.3.4 1.6 1.2 3.3 1.9 4.4 1.1 1.9 2.6 3.5 4.4 4.7 1.8 1.2 4.8-.2 6.5-1 2.5-1.2 4.2-3.5 4-6.3-.1-.1-.1-.2-.2-.4z",
    style: {
      fill: '#AF5760'
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.3 18.2c-.4-1.5-1.2-2.7-2.9-2.9v-1.1c2 .4 2.8 2.1 2.9 4z",
    style: {
      fill: '#AF5760'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.3 12.9c-.1-.3-.2-.6-.3-.8-.4-.7-.5-1.9-1.6-2-1.1-.2-1.9.9-2 1.7-.4-3.5-3.4-1.6-3.4.6-.5-1.9-1.8-1.3-2.2-.9-.6.6-1.6 1.5-1.4 2.3-1.4-.4-2.2.7-2.6 1.8-.1.4-.2.8-.1 1.3-.2-.9-.3-1.7-.1-2.3.4-1.2 1.3-1.9 2.7-1.6-.1-.9.4-2.2 1.2-2.5.8-.3 1.8 0 2.3.8 0-2.2 2.6-2.3 3.4-.6.2-.8.9-1.2 1.6-1.1 1.1.1 1.8.7 2.1 1.5.2.5.3 1.2.4 1.8z",
    style: {
      fill: '#DC8A84'
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.2 15.3c.5-.7.4-1.8.3-2.5 0-.7-.2-1.4-.4-2-.1 1.3-.8 2.8-2 3.5l-.5.3c0 .6.7 1.2 1.4 1.2.6 0 1-.2 1.2-.5z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.6 11.9c.2 1.4 1.7 2.7 1.4 4.1 0 .2-.3.4-.5.6-.4.4-1.1.5-1.7.3-.3-.1-.6-.2-.8-.4-.1 0-.6-.7-.5-.7 2.1-.2 2.4-2.2 2.1-3.9z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.4 18.4c.6.9 1.9 1.2 3 .9 1-.3 1.8-.1 2.9.1 2 .3.4-2.7-.9-2.8-.4 0-.8.1-1.2.3-.4.2-.7.4-1.1.6-1 .3-2 .3-2.9-.3-.1.5 0 .9.2 1.2z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.9 15c0-.4-.1-.8-.2-1.1.4 1.4 2.9 3.3.8 4.6-.6.4-1.7.3-2.3-.2 1.4-.3 1.8-1.9 1.7-3.3z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.3 14.3c0-.5-.1-1-.1-1.5-.1-.5-.4-1.1-.4-1.6 0 .6-.7 1.6-1.1 2-.6.6-1.7.9-2.6.7 0 0 .4 1 .5 1.1.3.2.7.2 1 .2.8-.1 1.5-.4 2.1-1",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.2 14.4c-4 .7-4.3.7-4.9 1.2-.6.5 0 .9.9.7s4.5-1.3 5-1.4-.1-.6-1-.5z",
    style: {
      fill: '#DC8A84'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.4 19.7c-.2.1-.4.3-.5.4-.3.4-.5.8-.6 1.3 0 .2-.1.7.1.9.4.3.7-.4.9-.7.7-.8 1.4-1.7 2.3-2.3 0 0-.6-.2-.7-.2-.2 0-.5.1-.7.1-.3.2-.6.3-.8.5z",
    style: {
      fill: '#DC8A84'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M198.8 14.5c-.1-.2-.2-.5-.3-.7-.5-.8-1.3-1.2-2.4-.9.1-.9-.4-2.2-1.2-2.5s-1.8 0-2.3.8c0-2.2-2.6-2.3-3.4-.6-.2-.8-.9-1.2-1.6-1.1-1.1.1-1.8.7-2.1 1.5-.3.5-.4 1.3-.4 1.9v1.4h-.1c-1.9.3-2.7 2-2.9 3.9v1c.2 2.5 1.8 4.5 4 5.6 1 .5 2.4 1.1 3.7 1.4 1 .2 2 .2 2.8-.3 1.8-1.2 3.3-2.9 4.4-4.7.6-1.1 1.5-2.8 1.9-4.4.1-.8.2-1.7-.1-2.3z",
    style: {
      fill: '#AF5760'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.5 13.8c-.3 1.3-.7 2.5-1.2 3.7-.2.6-.3.7-1 .9-.4.1-1.4.2-1.7-.1.3.3.7.5.9.9.5.7.3 1.4-.1 2.1-.6.8-1 1.3-1.6 2-.6.6-1.2 1.2-1.9 1.7-.3.3-.7.5-1.1.7-.2.1-.9.6-1.1.6 1 .2 2 .2 2.8-.3 1.8-1.2 3.3-2.9 4.4-4.7.6-1.1 1.5-2.8 1.9-4.4.2-.9.3-1.7.1-2.3-.1-.4-.2-.6-.4-.8z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182 18.2c.1-.8.7-1.8 1.3-2.3.3-.3.8-.5 1.2-.6.6-.1 1.2-.2 1.8-.1v-.8c-1.1-.3-2.3-.1-3.2.7-.7.7-1.1 1.7-1.2 2.7.1.1.1.3.1.4z",
    style: {
      fill: '#DC8A84'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.1 12.9c.1-.3.2-.6.3-.8.4-.7.5-1.9 1.6-2 1.1-.2 1.9.9 2 1.7.4-3.5 3.4-1.6 3.4.6.5-1.9 1.8-1.3 2.2-.9.6.6 1.6 1.5 1.4 2.3 1.4-.4 2.2.7 2.6 1.8.1.4.2.8.1 1.3.2-.9.3-1.7.1-2.3-.4-1.2-1.3-1.9-2.7-1.6.1-.9-.4-2.2-1.2-2.5s-1.8 0-2.3.8c0-2.2-2.6-2.3-3.4-.6-.2-.8-.9-1.2-1.6-1.1-1.1.1-1.8.7-2.1 1.5-.3.5-.4 1.2-.4 1.8z",
    style: {
      fill: '#DC8A84'
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.1 15.3c-.4-.5-.5-1.5-.5-2.1 0-.2.1-.3.3-.4.1 0 .3 0 .4.1.1.1.2.2.2.3.8 1.2 2.3-.3 2.9-1-.1.4-.1.8-.2 1.2-.2 1-.6 2.2-1.9 2.3-.6.1-1-.1-1.2-.4z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.2 13.7H191.9c-.4.2-.3.5-.4.9 0 .5-.3.9-.2 1.4 0 .2.3.4.5.6.5.5 1.3.6 1.9.4.3-.1 1.4-.6 1.4-.9 0-.2.3-.7.3-.9.1-.4.3-.9.4-1.3.1-.2.1-.4.1-.6s-.2-.4-.4-.4-.3.1-.4.2-.1.3-.2.4c-.3.6-1.7 2.6-2.3 1.3-.1-.4.1-.9-.4-1.1z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.9 18.4c-.1.2-.3.3-.4.4-.7.5-1.7.7-2.6.5-1-.3-1.8-.1-2.9.1-2 .3-.4-2.7.9-2.8.4 0 .8.1 1.2.3.4.2.7.4 1.1.6.6.2 1.2.2 1.8 0 .2-.1.4-.2.6-.1.3.1.5.4.4.8.1 0 0 .1-.1.2z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.6 15.2c-.5 0-.9-.2-1.3-.4-.2-.1-.3-.2-.5-.2s-.4.2-.7 0c-.1-.1-.2-.2-.2-.4s0-.3.1-.5c.8.2 1.6.1 2.3-.2s1.3-.9 1.7-1.6c.1 1.2.5 3.5-1.4 3.3z",
    style: {
      fill: '#823740'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.5 14.3c1.7 0 4.9.9 5.5 1.4.6.5 0 1.1-.9.7-.8-.4-2.8-1.2-4.5-1.1-.5 0-1-1-.1-1z",
    style: {
      fill: '#DC8A84'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.9 19.7c.2.1.4.3.5.4.3.4.5.8.6 1.3 0 .2.1.7-.1.9-.4.3-.7-.4-.9-.7-.7-.8-1.4-1.7-2.3-2.3 0 0 .6-.2.7-.2.2 0 .5.1.7.1.3.2.6.3.8.5z",
    style: {
      fill: '#DC8A84'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M153.5 75.2c-6.6 11.9-11.3 25.2-11.3 25.2 1.9.5 3.3.3 3.9.1.2-.1.4-.2.5-.4.6-1.5 5.6-15.8 7.6-23 .1-.9-.7-1.9-.7-1.9z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M140 78.1c.4 10.8 2.1 22.2 2.1 22.2-1.9-.2-3.2-.8-3.7-1.2-.2-.1-.3-.3-.3-.6-.1-1.6-.3-12.6-1.1-19 1.2-1 3-1.4 3-1.4z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "m146.5 102.2-2.8-.3c0-.1.1-.3.1-.4.1-1.1-.6-2-1.5-2.1-1-.1-1.8.7-1.9 1.7v.4l-2.8-.3c-.6-.1-1.1.4-1.1 1l-1.7 16c-.1.6.3 1.2.9 1.2l9.1.9c.6.1 1.1-.4 1.1-1l1.7-16c-.1-.5-.5-1-1.1-1.1z",
    style: {
      fill: '#D4DFD4'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "m138.2 119.9 6.4.6c.6.1 1.1-.4 1.1-1l1.7-16c0-.3 0-.6-.2-.8l-9 17.2z",
    style: {
      fill: '#1E9A48'
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M144.6 104.6c.3 10.4-.9 15.5-2.4 15.6l2.4.2c.2 0 .4 0 .6-.1.3-.2.5-.5.5-.9l1.7-16v-.4c-.1-.4-.4-.7-.9-.8l-2.8-.3c0-.1.1-.3.1-.4.1-.6-.1-1.2-.5-1.6 0 0 .4 1.6-.8 2.3-.6.4 1.9.4 2.1 2.4z",
    style: {
      opacity: 0.65,
      fill: '#FFFFFF',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M141.6 101.9c-.1 0-.2-.1-.2-.2-.7-.6-.4-1.5 0-2 .3-.3.7-.4.9-.4h-.1c-1-.1-1.8.7-1.9 1.7v.4l-2.8-.3c-.6-.1-1.1.4-1.1 1l-1.5 14.1c1.2-6.1 4.8-12.1 6-14 .6.6 1.1 0 .7-.3z",
    style: {
      fill: '#7EC187'
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M26.6 35.4 26 23.9c0-.6-.5-1.1-1.2-1.1h-2.1c-.8 0-1.4.8-1.1 1.5l3.5 11.3c.2.9 1.5.7 1.5-.2z",
    style: {
      fill: '#FAEA91'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "m16.7 38.6-7.3-9.8c-.5-.7-1.6-.8-2.2-.1L6 29.9c-.6.6-.5 1.6.1 2.1l9.4 7.7c.8.5 1.7-.4 1.2-1.1z",
    style: {
      fill: '#FAEA91'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M11.9 48.3 3.5 45c-.9-.4-1.9.2-2.1 1.2l-.3 1.6c-.2.9.5 1.8 1.5 1.8l8.9.2c1 0 1.2-1.2.4-1.5z",
    style: {
      fill: '#FAEA91'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M98.2 135.2s19.9-2 24.3-2.4c4.5-.4 1.6-8.9-1.7-10s-18-1.2-25.1-.9c-7.1.3-6.3 14.1 2.5 13.3z",
    style: {
      fill: '#283F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.2 122.2c1.7-.6 6.5-.1 8.3.8 1.6.8 1.8 6.1.8 8.9-.2.5-.5.8-1 .9-3.3.6-6.4.8-8.2.5-2-.4-1.6-10.5.1-11.1z",
    style: {
      fill: '#1B9B48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M141.1 119.7c-.1-.1-.2-.3-.3-.4-.1-.2-.3-.3-.5-.5l-3.6-2.2c-.6-.4-1.4-.5-2.1-.2-1.8.6-3.7 1.2-5.5 1.8-2 .7-2.7 1.2-3.1 2.2 0 .1.1.1.1.2-.1 0-.1-.1-.2-.1-.3.7-.4 1.6-.5 3-.3-.1-1.9-.3-3-.5-.7-.1-1.4.3-1.6 1-.3 1.1-.4 2.5-.3 3.9.2 1.7.7 3.3 1.9 4 1.8 1.1 6.1 1 8.5.9 1.1-.1 2.1-.4 3.1-.9l5.6-3c.8-.4 1.3-1.2 1.4-2v-.5l.5-5.1c0-.3 0-.6-.1-1-.1-.2-.1-.3-.2-.5 0 .1-.1 0-.1-.1z",
    style: {
      fill: '#F5B694'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M141 119.6c-.2-.3-.4-.5-.7-.7l-3.6-2.2c-.6-.4-1.4-.5-2.1-.2-1.8.6-3.7 1.2-5.5 1.8-2 .7-2.7 1.2-3.1 2.2 2.3 5.6 9.9 1.7 15-.9z",
    style: {
      fill: '#FDD3B5'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M125.2 131.3c-1.5-.7-3.3-1.9-4.7-3.3.2 1.7.7 3.3 1.9 4 1.8 1.1 6.1 1 8.5.9 1.1-.1 2.1-.4 3.1-.9l5.6-3c.8-.4 1.3-1.2 1.4-2v-.5c-4.4 3.7-10.1 5.9-15.8 4.8z",
    style: {
      fill: '#B26E67'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M125.6 124.4c-.1 1.7 1.2 3.1 2.9 3.1.7 0 1.4 0 2.2-.1-.8.2-2.6-1-3.4-1.4-1.1-.7-1.2-4.3-1.3-5.3-.1.8-.3 1.6-.4 3.7z",
    style: {
      fill: '#B26E67'
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st25",
    points: "127.1,119 133.6,122.8 128.2,118.7",
    style: {
      fill: '#F5B694'
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st25",
    points: "130.4,118.1 136.4,121.8 131.4,117.7",
    style: {
      fill: '#F5B694'
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st25",
    points: "133.2,117.1 138.9,120.6 134.4,116.7",
    style: {
      fill: '#F5B694'
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st27",
    points: "131.6,130.3 130.5,127.3 128.8,123.1 128.4,123.9 129.2,127.6",
    style: {
      fill: '#B26E67'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M104.1 158.2c2.6-1.3 5.5-2.6 8.6-4-4.5-12.7-7-26.5-7-26.5s5.2-10.1 7.6-18.7c1.3-4.7 1.7-9-.2-10.7C105.3 91.2 69 75.5 69 75.5c-3.3-1.4-6.1-1.4-8.5-.2-1.4.7-2.6 1.8-3.6 3.1-5.6 5.2-10.4 10.9-14.3 16.4-1.3-1-3.5-2.6-5.3-4.2 0 0-19.5 13.8-7 23.6.2.1.3.3.5.4-.6 1.3-.9 2-.9 2l6.9 4c5 2.9 11.4 1.6 14.8-3.1 1.1-1.5 2.2-3.1 3.4-4.7 5.2 22.2 10.1 41.9 14.2 52.6 10.9 2 23-1.3 34.9-7.2z",
    style: {
      fill: '#3B545C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M113.1 98.2c-7.8-7-44.1-22.7-44.1-22.7-3.3-1.4-6.1-1.4-8.5-.2-1.4.7-2.6 1.8-3.6 3.1-5.6 5.2-10.4 10.9-14.3 16.4 6.9-5.4 13.9-11.4 21.8-15.7 1.9-1 4.1-1.2 6.1-.4 17.6 6.2 35.7 15 42.8 30.3 1.3-4.8 1.7-9-.2-10.8z",
    style: {
      fill: '#24786F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M113.1 98.2c-7.8-7-44.1-22.7-44.1-22.7-3.3-1.4-6.1-1.4-8.5-.2-1.4.7-2.6 1.8-3.6 3.1-5.6 5.2-10.4 10.9-14.3 16.4 6.9-5.4 13.9-11.4 21.8-15.7 1.9-1 4.1-1.2 6.1-.4 17.6 6.2 35.7 15 42.8 30.3 1.3-4.8 1.7-9-.2-10.8z",
    style: {
      fill: '#24786F'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "m97.3 75-2.6 18.3s-13.6-.7-13.6-6.9c0-7.2 4.2-17.6 4.2-17.6l12 6.2z",
    style: {
      fill: '#F5B694'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "m92.9 76.3-7.6-7.5s-4.2 10.4-4.2 17.6c0 3.2 3.7 5 7.2 5.9-1.5-7.5-3-14 4.6-16z",
    style: {
      fill: '#CC7B6D'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M95.5 87.8c-4.1 13.2-4.9 23.5-4.9 23.5 2 .1 3.3-.4 3.9-.7.2-.1.4-.3.4-.5.3-1.6 3.2-13.7 4.9-20.1-1.4-1.4-3.6-2-4.3-2.2z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M81.5 81.2c5 12.9 9 29.9 9 29.9-1.9.2-3.4-.2-4-.4-.2-.1-.4-.3-.4-.5-.4-1.4-5-17-7.5-25.2-.6-1.9.7-3.8 2.6-3.9.2 0 .3 0 .3.1z",
    style: {
      fill: '#1E9A48'
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "m95.3 112.2-2.9.3v-.5c-.1-1.1-1-1.9-1.9-1.8-1 .1-1.7 1.1-1.6 2.1 0 .2 0 .3.1.4l-2.9.3c-.6.1-1 .6-.9 1.2l1.6 16.3c.1.6.6 1.1 1.1 1l9.2-1c.6-.1 1-.6.9-1.2L96.4 113c0-.4-.5-.8-1.1-.8z",
    style: {
      fill: '#D4DFD4'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "m90.6 131.5 6.5-.7c.6-.1 1-.6.9-1.2l-1.6-16.3c0-.3-.2-.6-.4-.7l-5.4 18.9z",
    style: {
      fill: '#1E9A48'
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M93.9 115c2.4 10.3 2.2 15.6.8 16l2.4-.3c.2 0 .4-.1.6-.3.3-.2.4-.6.4-1l-1.6-16.3v-.2c0-.1 0-.1-.1-.2-.2-.4-.6-.6-1-.6l-2.9.3v-.5c-.1-.6-.4-1.2-.8-1.5 0 0 .7 1.5-.4 2.5-.5.7 1.9.2 2.6 2.1z",
    style: {
      opacity: 0.65,
      fill: '#FFFFFF',
      enableBackground: 'new'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M90.3 113c-.1 0-.2-.1-.3-.1-.8-.4-.7-1.4-.4-2 .3-.4.7-.5.9-.5h-.1c-1 .1-1.7 1.1-1.6 2.1 0 .2 0 .3.1.4l-2.9.3c-.6.1-1 .6-.9 1.2l1.4 14.3c-.1-6.3 2.3-13 3.2-15.2.7.3 1.1-.4.6-.5z",
    style: {
      fill: '#7EC187'
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M99.4 42.7c-.5-.2-1.5-.5-2.7-.8 5 9 8.3 19.3 8.2 30 .5-.9.9-2 1.3-3.2 2-7.4-3.9-24.7-6.8-26z",
    style: {
      fill: '#FDD3B5'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M78.5 44.9c-2.8 5.8-1 19 3.5 25.4 3.3 4.7 9.8 7.3 13.6 7.1 2.8-.1 6.9-1.2 9.3-5.5.1-10.7-3.2-21.1-8.2-30-5.3-1-15.9-1.7-18.2 3z",
    style: {
      fill: '#F8B795'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M85.3 64.2V63c.3-4.2 1.4-8.5 2-12.6.1-1 .3-2 .1-3-.1-1-.6-2-1.5-2.5-2.8-1.7-6.5 2.4-7 4.8-.5 2.5.1 5.1.8 7.5-1.7-.7-1-.7-2.4.6-4.1 3.7-2 10.4 2.3 10.9.5.1.9 0 1.2-.1.3.6.7 1.3 1.1 1.8 3.3 4.7 9.8 7.3 13.6 7.1 1.9-.1 4.4-.6 6.5-2.2.4-.4.9-.8 1.3-1.2-3.2 3.6-11.7 1.1-14.9-1.2-2.3-2-3.1-5.6-3.1-8.7z",
    style: {
      fill: '#CC7B6D'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M81.7 58.1c5.6-1.2 6.7-16.9-3.8-14.6-4.9 1.2-4.5 16.4 3.8 14.6z",
    style: {
      fill: '#521C2A'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M103.9 31.7c1.6 1.9-.2 6.9-13.6 6-6-.4-10.4.4-13.2 2-2.1 1.2-3.3 2.9-3.5 4.8-.7 6.3 7.5 3.9 11.5 3.2 3.9-.7 8.1-.6 17.5-.4h.5c9.8.3 9-12.2.8-15.6z",
    style: {
      fill: '#833640'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M77.1 39.7c-2.1 1.2-3.3 2.9-3.5 4.8-.7 6.3 7.5 3.9 11.5 3.2 3.9-.7 8.1-.6 17.5-.4 2-.4 5-4.1 2.8-9.2-6 6.1-19.3 5.4-28.3 1.6z",
    style: {
      fill: '#521C2A'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M79.8 68.7c2.2.3 3.4-1.5 3.7-3.7-.3-3.1-2.3-6.5-6.2-6.7-2.4-.1-3.7 1.5-3.9 3.5.2 3 2.4 6.4 6.4 6.9z",
    style: {
      fill: '#CC7B6D'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M77.2 58.3c2 .1 3.6 1.1 5.4 1.9-.3-.1-.7-.9-.9-1.1-.4-.4-.8-.8-1.2-1.1-.9-.7-2.1-1.1-3.2-1.1-3-.1-4.2 2.3-3.9 5 .2-2.2 1.4-3.8 3.8-3.6z",
    style: {
      fill: '#F8B795'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M91.7 58.3v1.1c0 .3-.1.5-.3.6-.2.1-.4-.1-.5-.4-.1-.2-.1-.5-.2-.7-.2-1.1-.4-2.1-.6-3.2-.1-.7-.1-1.1-.1-1.6 0-.3 0-.5.2-.6s.3-.1.5.1c.1.1.2.2.2.3.1.3.2.5.3.8.2 1.2.4 2.4.5 3.6z",
    style: {
      fill: '#3C131C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.8 54c.3.8.6 1.6.8 2.5.1.7.3 1.4.4 2.1 0 .3 0 .6-.2.8-.3 0-.5-.2-.6-.5s-.2-.7-.3-1c-.3-1.1-.6-2.3-.8-3.5 0-.2-.1-.4-.1-.6-.4-1.3.5-.6.8.2z",
    style: {
      fill: '#3C131C'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M91.5 60.2c-.3 0-.6-.1-.9-.1h-1.2c-.3 0-.6.1-.9.2-.3.1-.3.5 0 .7s.7.1 1 .1c.4 0 .7 0 1.1-.1.4 0 .7-.1 1-.1s.7 0 .9-.3c.1-.1 0-.3-.1-.4-.2-.1-.5-.1-.7-.2-.1.2-.1.2-.2.2z",
    style: {
      fill: '#EFA389'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M95.1 162.1c-2.3-3.6-4.6-7.4-5.1-8.1-3.7-5.4-7.3-10.8-10.3-16.6-6.9-13-8.6-26.6-11.9-40.7-.1-.3-.9-2.4-1-2.7-4.1 5-7.4 11.8-12.6 15.5 5.4 23.5 10.2 44.8 14.7 55.9 8.3 1.5 17.2 0 26.2-3.3z",
    style: {
      fill: '#283F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.8 112.5c-1.3 2.5-5.9 2.5-5.9 2.5l10.9 5.6c5 2.9 11.4 1.6 14.8-3.1 3.9-5.3 8.8-12 12.1-16.3 1.6-2.1 2.6-4.7 3.2-7.4-11.6 9.2-20.3 26.8-35.1 18.7z",
    style: {
      fill: '#283F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.4 84c2.7 2 4 3.4 6.2 6 .4.4.6 1 .7 1.6 3.2 9.5.8 27.7-13.1 23.4-3.5-1.1-8.5-3.9-8.3-8 .1-3.1.2-6.1.6-9.1.3-2.9.7-5.9 1.4-8.8.4-1.5.7-4 2-5.1 2.9-2.6 6.7-2.9 10.5 0z",
    style: {
      fill: '#1B9B48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.8 96.8c0-1-.1-2-.4-2.8-.4-1.3-.8-2.7-.9-4-.2-2.3.2-4.7.4-7 .2-2 .3-4.4-.7-6.1-.9-1.7-1.8-3-2.2-5.1-.8-4.2-3.2-10.5-1.1-15.7 1.5-3.9 2.5-8.1-.1-10.2-.3-.2-.6-.4-1-.6-.8-.4-1.9-.6-3.2-.7-6.7-.3-10.5 12.3-9 23.7.3 2.2-1.1 4.1-3.3 4.6-2.5.6-4.3.4-5.8 1.2-1 .6-2.1 2.1-2.8 3.3-1.3 2.4-1.2 5.3.8 8.3-1.7.6-2.9 1.9-3.6 3.4-1.9 4-1.6 7.6 1.9 9.7-.1 0-2.1 3.3-1.8 6.6.3 3.1 1.9 10.8 10.9 10.4 7.3-.3 16.5-2.1 19.6-9.7 1.4-2.6 2.4-6.2 2.3-9.3z",
    style: {
      fill: '#F8B795'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M36 96.5c-.1-1-1.3-5.2-1.4-6.5-.2-2.3.2-4.7.4-7 .2-2 .3-4.4-.7-6.1-.9-1.7-1.8-3-2.2-5.1-.8-4.2-3.2-10.5-1.1-15.7 1.5-3.9 2.5-8.1-.1-10.2 2.1 4.8-8.5 12 .5 31.3.8 1.7 1 5.4.7 7.3-1.5 9.2 3.2 13.6 2.6 19.7.7-2.1 1.5-4.9 1.3-7.7z",
    style: {
      fill: '#FDD3B5'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "m21.6 77-13-3c-1.5 1-2.1 2.1-2.8 3.3 5.6 2 10.3 1.1 15.8-.3z",
    style: {
      fill: '#FDD3B5'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "m20.3 107-4.8.9 1.9.1-1.9-.1-1.2.2 1.2-.2-7.6-.3c.2.1.4.1.6.1-.7 1.2.2 2.8 1.6 3 4.4.8 6.4-.1 10.2-3.7z",
    style: {
      fill: '#FDD3B5'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M22.6 88.4 6.2 85.9c-1.4.7-2.5 1.8-3.1 3.2 6.5 1.8 13.5 4.8 19.5-.7z",
    style: {
      fill: '#FDD3B5'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M7 85.9c5.1.7 11 1.8 16.1.5 2.1-.6 4.6-1.8 4.1-4.3-.2-1.1-.8-2.1-1.6-2.9-.7-.7-2.9-1.7-3.7-2 0 3.5-.7 7.4-5.3 8.4-3.2.7-6.4.2-9.6.3z",
    style: {
      fill: '#B26E67'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M5.1 98.9c4.6.4 9.5.7 14.1-.3 2.3-.5 7.8-2.1 8.5-4.6.3-1.2-.1-2.5-.9-3.4s-2-1.5-3.2-1.7c-.5 4.2-2.4 6.2-6.3 7.6-4 1.3-8 2.1-12.2 2.4z",
    style: {
      fill: '#B26E67'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M7.6 107.3c7.3 1.8 16.6-.6 18.9-4.5.8-1.3.4-2.4-.4-3.7-.9-1.4-3.1-2.1-5.5-1.7.4 3.1-.6 6.8-3.7 7.9-3 1.2-6.1 1.7-9.3 2z",
    style: {
      fill: '#B26E67'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M9.5 115.2c.2 0 2.2 1.1 4.9 1.3 1.3.1 2.6-.2 3.9-.5 3.2-.8 9.4-3.9 5.6-7.5-1.1-1.1-2.7-1.6-4.2-1.9.1 2 .1 6.1-1.8 7.4-1.5 1.3-6.7 1.4-8.4 1.2z",
    style: {
      fill: '#B26E67'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M105.7 127.6c.5-14 2.1-14 1.1-20.6s-2.9-6.9-2.9.8 1.8 19.8 1.8 19.8z",
    style: {
      fill: '#283F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M42.6 94.7c5.4 4.2 8.6 7.3 8.6 7.3l.1-.9c.3-2.1-1-4.1-3.1-4.7l-5.6-1.7z",
    style: {
      fill: '#283F46'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M90.3 63.7s-.3 4.1 3.1 4.2c3.8.1 3.6-3.8 3.6-3.8",
    style: {
      fill: '#F7F0F6'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M94.6 68.2c.6-.2 1.2-.5 1.6-.9 1.2-1.2 1.1-3.1 1.1-3.2 0-.2-.2-.4-.4-.4s-.4.2-.4.4c0 0 .1 1.6-.9 2.6-.5.5-1.3.8-2.3.8-.8 0-1.4-.3-1.9-.8-1-1.1-.8-3-.8-3 0-.2-.1-.4-.4-.4-.2 0-.4.1-.4.4 0 .1-.2 2.2 1 3.6.6.7 1.4 1 2.4 1 .6 0 1 0 1.4-.1z",
    style: {
      fill: '#641A26'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M99.5 64.5c.2 0 .3-.2.3-.3l.6-5.2c0-.1 0-.3-.2-.4-.1-.1-.3-.1-.4 0l-1.9 1c-.2.1-.3.3-.2.5.1.2.3.3.5.2l1.2-.6-.4 4-8.7-.4c-.2 0-.4.2-.4.4s.2.4.4.4l9.2.4c-.1 0-.1 0 0 0z",
    style: {
      fill: '#641A26'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M8.8 101.2c6.5 1 11.3-2.6 11.3-2.6l-10.4.9",
    style: {
      fill: '#FDD3B5'
    }
  }))));
};

var SvgDocumentSendSuccess = function SvgDocumentSendSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 200 166",
    style: {
      enableBackground: 'new 0 0 200 166'
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, '.st0{fill:#B4D2D6;}\n\t.st1{fill:#8FB7BF;}\n\t.st2{fill:#106275;}\n\t.st3{fill:#29BBD3;}\n\t.st4{fill:#1895B2;}\n\t.st5{fill:#A3CF5F;}\n\t.st6{fill:#6CBC45;}\n\t.st7{fill:#219E48;}\n\t.st8{fill:#FFFFFF;}'), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.2 63.5c9.5-5.4 29.1-16.6 46.8-27.2 21.7-13 49.7-7.2 64.3 13.5 16.3 23 32.9 50 30.6 61.6-3.1 15.8-33.4 56.6-78.7 46.2-23-5.3-56-38.6-66.3-49-13.3-13.7-19.8-31.9 3.3-45.1z",
    style: {
      fill: '#B4D2D6'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.2 129.1C4.1 171 13.6 113.7 21.6 95.3c-3.7 14.8-16.4 68.7 48.5 20.2-1.3 2.6-.3 11-1.9 13.6z",
    style: {
      fill: '#8FB7BF'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m58.2 101.6 19.7 2.9 14.4 35.1c.4.4 1 .5 1.5.1l90.1-70.2-125.7 32.1z",
    style: {
      fill: '#106275'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.2 128.5c-1.2-.8-2.7-1.3-4.5-1.3-85.9 66.6-70.4-15.5-60.3-36.7-19 31.3-28 117.8 69.7 50.6l-4.9-12.6z",
    style: {
      fill: '#8FB7BF'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m43.6 84.7 144.7-19.2c1.3-.2 1.9 1.5.8 2.2L56 156.7c-1.2.8-2.9-.2-2.7-1.6l4.8-45.9c.1-1 .8-1.9 1.8-2.2l112.7-34.5-112.9 29c-.9.2-1.9 0-2.5-.7L42.9 86.6c-.6-.6-.2-1.8.7-1.9z",
    style: {
      fill: '#29BBD3'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m84.1 79.3-40.5 5.4c-.9.1-1.3 1.2-.7 1.9L57 100.9c.7.7 1.6.9 2.5.7l36.1-9.3c-6.6-1.4-10.7-6.8-11.5-13z",
    style: {
      fill: '#1895B2'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82 100.3 59.8 107c-1 .3-1.7 1.1-1.8 2.2l-4.8 45.9c-.2 1.5 1.5 2.5 2.7 1.6l81.3-54.3c-20.5 5.2-54.7 7.7-55.2-2.1z",
    style: {
      fill: '#1895B2'
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.4 119.7c-10.9 0-19.7 8.8-19.7 19.7 0 10.9 8.8 19.7 19.7 19.7 10.9 0 19.7-8.8 19.7-19.7.1-10.9-8.7-19.7-19.7-19.7z",
    style: {
      fill: '#A3CF5F'
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M160.2 120.3c-12.5 1.3-22.5 10.6-24.2 22.5 1.6 9.3 9.7 16.4 19.4 16.4 10.9 0 19.7-8.8 19.7-19.7.1-9.3-6.3-17.1-14.9-19.2z",
    style: {
      fill: '#6CBC45'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M173.4 131.2c.1.7.1 1.3.1 2 0 13.1-10.6 23.7-23.7 23.7-1.4 0-2.8-.1-4.1-.4 2.9 1.7 6.2 2.6 9.8 2.6 10.9 0 19.7-8.8 19.7-19.7 0-2.9-.7-5.7-1.8-8.2z",
    style: {
      fill: '#219E48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m146.6 137.2-1.6 3.4c-.3.6-.1 1.2.4 1.6l7.4 5.3c.6.4 1.4.3 1.8-.3 1.7-2.4 6.3-8.6 11.1-15 1-1.3-.8-2.8-1.9-1.7-3.9 3.9-7.4 7.7-9.8 10.8-.2.3-.6.3-.9.1-1.3-1.2-3.2-3.2-4.4-4.5-.6-.7-1.7-.5-2.1.3z",
    style: {
      fill: '#FFFFFF'
    }
  })));
};

var SvgPadlockClosed = function SvgPadlockClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 166"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.cls-1{fill:#d1dfbd;}.cls-2{fill:#f4f7e9;}.cls-3{fill:#d7d6c3;}.cls-4{fill:#b7b8ad;}.cls-5{fill:#165e50;}.cls-6{fill:#003b30;}.cls-7{fill:#219c48;}.cls-8{fill:#49b35d;}.cls-9{fill:#fffce6;}.cls-10{fill:none;}')), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.65 33.11c-13.75-2.43-23 2.19-27.6 15.74-6.26 18.34-21.61 56.15-22.22 57.94-7.16 20.59 14.55 28.77 29.2 35.09 24.51 10.56 50.51 16.69 76.82 20.73 9.5 1.46 24.9 6.53 33.48.53 4.9-3.42 6.18-8.85 7.55-14.3a298.61 298.61 0 0 0 8.64-57.17c.62-11.51-3.82-17.45-14.22-21.9-15.52-6.63-31.07-13.19-46.56-19.89-14.49-6.26-28.62-13.57-44.24-16.61Z",
    style: {
      fill: '#d1dfbd'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.61 107.22a13.76 13.76 0 0 0 8.85-8.36l11.42-35.28a13.15 13.15 0 0 0-1.1-10.58L125 46.4l-15.26 47.29c-.72 2.12-1.55 4.47-3.6 4.47H40.8l6.8 5.67c3 2.49 5.34 3.85 9.21 3.85h49.67a11 11 0 0 0 3.13-.46Z",
    style: {
      fill: '#f4f7e9'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.32 61.13h5.66l13.71-37.71C83 17 90.29 11.74 96.87 11.74S107 17 104.67 23.42L91.52 60.65c1.71-.11 3.43-.24 5.16-.41 1.49-.23 3-.48 4.48-.76l12.6-36.06c4-11.34-2.18-20.54-13.72-20.54-11.55 0-24.28 9.2-28.44 20.54L57.71 61.27a25.7 25.7 0 0 1 3.61-.14Z",
    style: {
      fill: '#d7d6c3'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.88 6.4a1.08 1.08 0 0 0-1.39.31 1.09 1.09 0 0 0 .14 1.45c3.29 3.09 4.15 8.13 2.3 13.5L98.52 51.75c-1.14.21-2.27.41-3.37.58l-.75.06h-.05a1.08 1.08 0 0 0-.93.72 1.12 1.12 0 0 0 .16 1 1.09 1.09 0 0 0 .86.42h.08c1.25-.09 2.41-.19 3.54-.29h.07c1.12-.18 2.28-.38 3.45-.6a1.08 1.08 0 0 0 .83-.71l10.42-30.13c2.42-6.97.48-13.42-4.95-16.4Z",
    style: {
      fill: '#b7b8ad'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m124.76 45.85-7.23-12.45-14 45.08a7 7 0 0 0-4.27.41c-7.68 3.3-12.56 5.82-9.26 11.64s11.86 10 11.86 10c5.56.25 7.8-.94 10.29-5.78a6.83 6.83 0 0 0 1-2.13l12.46-38.89a9.71 9.71 0 0 0-.85-7.88Z",
    style: {
      fill: '#165e50'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.17 96.83c1.36 1.6 1 3.66-.93 3.66h-55.8A10.47 10.47 0 0 1 40.62 98L29.7 88.78l63.07.81c6.34.02 7.42 2.54 11.4 7.24Z",
    style: {
      fill: '#003b30'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.55 89.57H32.44c-3.55 0-5.34-2.87-4-6.41l17-45.39c1.33-3.54 5.2-6.41 8.65-6.41h59.63c3.45 0 5.27 2.87 4.06 6.41l-15.62 45.39a9.87 9.87 0 0 1-8.61 6.41Z",
    style: {
      fill: '#219c48'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54 31.36c-3.45 0-7.32 2.87-8.65 6.41l-17 45.39c-1.32 3.54.47 6.41 4 6.41h.49c29-56.17 65.76-58.21 65.76-58.21Z",
    style: {
      fill: '#49b35d'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M86.45 46.62c-.93-2.43-3.3-4-6.63-4-5.45 0-11.42 4.27-13.33 9.54a7.47 7.47 0 0 0 .23 6.36 2.25 2.25 0 0 1-.06 2.36l-8.93 13.34c-.85 1.26-.31 2.52 1.07 2.52h4.53A2.23 2.23 0 0 1 65 76a2.63 2.63 0 0 1 .58.07 1.67 1.67 0 0 1 .32 0c.34-.12.86-.37 1.17-.45.72-.18 1.47-.24 2.2-.35a43.51 43.51 0 0 1 5.07-.7 2.75 2.75 0 0 1 .66.06l.09-.26c.43-1.39.81-2.81 1.1-4.23.63-3.11.79-6.28 1.43-9.38a2.39 2.39 0 0 1 .25-1.62c1-2 1.62-4 3.31-5.51s3.74-2.37 3.54-4.8a2 2 0 0 1 1.73-2.21Z",
    style: {
      fill: '#165e50'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71.11 55.94a7.5 7.5 0 0 0 .23 6.36 2.23 2.23 0 0 1-.06 2.36l-8.07 12.08h13.17a3 3 0 0 0 2.88-2.52l.65-13.51a2.24 2.24 0 0 1 1-1.73 14.63 14.63 0 0 0 5.44-6.84 7.92 7.92 0 0 0 .13-5.52 9.1 9.1 0 0 0-2-.22C79 46.4 73 50.67 71.11 55.94Z",
    style: {
      fill: '#003b30'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M73.72 26.72a1.51 1.51 0 0 1-.5-.09 1.4 1.4 0 0 1-.8-1.81c4.25-11.15 11-14.61 11.28-14.75a1.4 1.4 0 0 1 1.3 2.51c-.08 0-6.1 3.2-9.93 13.24a1.39 1.39 0 0 1-1.35.9Z",
    style: {
      fill: '#fffce6'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M132 133.16a7.41 7.41 0 0 0 6.25-4.72L150.6 91 143 77.81l-12.25 37.25a13.25 13.25 0 0 1-7.8 7.79 10.68 10.68 0 0 1-3.66.69H71.14l11.49 9.62H132Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M143.25 146.63a10.29 10.29 0 0 0 7-6.62c2.46-6.88 7.39-21.91 10.46-31.34L154 96.86 143 130a12.67 12.67 0 0 1-7.54 7.5 10.11 10.11 0 0 1-3.45.63H88.59L99 146.89c12.26 0 29.31-.08 42.73-.08a7.09 7.09 0 0 0 1.52-.18Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M106.14 98.16c2 0 2.88-2.35 3.6-4.47l17.12-44-9.33-16.29-42.66 14.91-8.56 3-2.15 2.09-33.88 33a2.37 2.37 0 0 1-1.17 1.91l14.55 12.2 60.14-2.3Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123 122.85a13.25 13.25 0 0 0 7.8-7.79l11.55-35.12a5 5 0 0 0-.41-4.08l-1.26-2.19a1.47 1.47 0 0 0-2.67.27l-12.9 39.21a6.88 6.88 0 0 1-5.77 4.39H68a1.47 1.47 0 0 0-.94 2.59l2.39 2a6 6 0 0 0 3.86 1.41h46a10.68 10.68 0 0 0 3.69-.69Z",
    style: {
      fill: '#f4f7e9'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.49 137.53A12.67 12.67 0 0 0 143 130l10.6-32.09a2.51 2.51 0 0 0-.21-2L151.76 93a1 1 0 0 0-1.89.19l-11.58 35.21a7.41 7.41 0 0 1-6.25 4.72H85.48a1 1 0 0 0-.67 1.84l3.09 2.58a2.48 2.48 0 0 0 1.6.58H132a10.11 10.11 0 0 0 3.49-.59Z",
    style: {
      fill: '#f4f7e9'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.06 149.92a14.55 14.55 0 0 0 8-8.57c2.12-5.95 6.08-17.92 9.1-27.17a2 2 0 0 0-.17-1.61l-1.36-2.37a.78.78 0 0 0-1.42.14c-3.09 9.46-7.6 23.18-9.92 29.67a10.29 10.29 0 0 1-7 6.62 7.09 7.09 0 0 1-1.52.18c-12.56 0-28.3 0-40.31.07a.89.89 0 0 0-.56 1.57l2.34 2a2 2 0 0 0 1.28.46c11.54 0 25.73-.06 37.25-.06a11.37 11.37 0 0 0 4.29-.93Z",
    style: {
      fill: '#f4f7e9'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M164.3 69.77c-15.52-6.63-31.07-13.19-46.56-19.89-14.49-6.26-28.62-13.57-44.24-16.61l-.85-.16c-13.75-2.43-23 2.19-27.6 15.74-6.26 18.34-21.61 56.15-22.22 57.94-7.16 20.59 14.55 28.77 29.2 35.09 19.89 8.56 40.75 14.21 62 18.2a1.85 1.85 0 0 1 1.84-1.86c10.74 0 21.14-.06 31.85-.06 6.88 0 10.46-5.67 11.58-8.81 2-5.5 4.8-14.11 7.61-22.7a1.86 1.86 0 0 1 3.38-.34 48.56 48.56 0 0 1 3.53 4.64 299.93 299.93 0 0 0 4.73-39.28c.59-11.51-3.85-17.45-14.25-21.9Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.88 126.65c-2.81 8.59-5.65 17.2-7.61 22.7-1.12 3.14-4.7 8.81-11.58 8.81-10.71 0-21.11 0-31.85.06a1.85 1.85 0 0 0-1.84 1.86q7.4 1.39 14.85 2.53c9.5 1.46 24.9 6.53 33.48.53 4.9-3.42 6.18-8.85 7.55-14.3 1.49-5.92 2.78-11.89 3.91-17.89a48.56 48.56 0 0 0-3.53-4.64 1.86 1.86 0 0 0-3.38.34Z",
    style: {
      fill: '#f4f7e9'
    }
  }));
};

var SvgSicrediIconNegative = function SvgSicrediIconNegative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sicredi-icon-negative",
    "aria-label": "\\xCDcone da Sicredi na varia\\xE7\\xE3o de negativo",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.228 7.859c-.005.902-.256 1.356-.567 1.39-.204.023-.438-.135-.651-.461a37.203 37.203 0 0 0-2.272-3.09l.002-.007c.314-1.579.818-3.19 1.68-4.59 1.077 2.028 1.821 4.503 1.808 6.758Zm-4.045-.053c.762.637.97 1.146.8 1.423-.112.182-.39.268-.797.223a39.98 39.98 0 0 0-4.105-.218l-.005-.006C5.775 7.783 4.598 6.155 3.842 4.397c2.578.57 5.369 1.76 7.34 3.41Zm-2.6 3.296c1.018-.2 1.574-.035 1.699.278.082.206-.02.482-.308.775-.953.97-1.826 1.99-2.665 3.052h-.007c-2.052.142-4.186.063-6.189-.403 2.04-1.687 4.806-3.177 7.47-3.702Zm1.162 4.065c.445-.884.92-1.216 1.248-1.124.214.06.372.303.43.693.183 1.23.448 2.437.77 3.645a.067.067 0 0 1-.004.005c-1.116 1.479-2.314 2.903-3.816 4.061-.178-2.39.287-5.124 1.372-7.28Zm3.854 1.45c-.397-.808-.367-1.357-.099-1.546.177-.124.457-.1.784.08.998.549 2.026 1.063 3.104 1.47l.001.006c.388 1.512.614 3.1.514 4.655-1.794-1.097-3.423-2.863-4.304-4.664Zm3.396-1.992c-.82-.17-1.213-.513-1.188-.825.017-.205.208-.403.544-.542 1.032-.427 2.05-.897 3.01-1.46.002 0 .003.002.005.003 1.271.605 2.492 1.374 3.475 2.347-1.786.65-3.997.859-5.846.477Zm.671-3.76c-.65.53-1.15.62-1.37.405-.143-.141-.172-.414-.063-.767.345-1.12.613-2.25.835-3.4a.042.042 0 0 0 .006-.002c1.31-.572 2.625-1.097 4.08-1.24-.688 1.833-1.933 3.735-3.488 5.004Z",
    fill: "#D7E6C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.42 1.102c-.861 1.4-1.365 3.01-1.68 4.59 0 .001 0 .004-.002.006-.215-.262-.503-.579-.75-.867-.941-1.093-1.98-2.116-3.033-3.12a11.31 11.31 0 0 1 5.465-.609ZM1 9.67c1.61-.184 3.226-.351 4.828-.402.413-.013.883-.033 1.253-.033l-.004-.006c-1.301-1.445-2.478-3.073-3.234-4.83A10.967 10.967 0 0 0 1 9.668Zm3.17 10.272c.758-1.287 1.555-2.563 2.428-3.765.232-.32.492-.686.711-.97l-.007.001c-2.052.142-4.186.063-6.188-.403a10.98 10.98 0 0 0 3.057 5.137Zm9.662 2.907c-.488-1.146-.955-2.3-1.327-3.464-.103-.323-.225-.699-.31-1.003a.036.036 0 0 1-.004.006c-1.116 1.478-2.313 2.901-3.816 4.06 1.814.496 3.576.729 5.457.4Zm7.526-5.009c-1.047-.247-2.089-.528-3.09-.896-.285-.105-.617-.217-.88-.322v.007c.388 1.511.614 3.098.515 4.654a11.074 11.074 0 0 0 3.455-3.443Zm1.406-8.33c-.84.644-1.703 1.27-2.616 1.815-.255.153-.545.338-.786.474l.005.003c1.27.605 2.492 1.374 3.474 2.347a13.794 13.794 0 0 0-.077-4.64Zm-5.196-6.983c-.077 1.205-.17 2.412-.345 3.591-.047.32-.1.693-.155.987l.006-.002c1.31-.573 2.625-1.098 4.079-1.24a11.084 11.084 0 0 0-3.585-3.336Z",
    fill: "white"
  }));
};

var SvgSicrediIcon = function SvgSicrediIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sicredi-icon",
    "aria-label": "\\xCDcone da Sicredi na varia\\xE7\\xE3o colorida",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.523 7.482c-.006.984-.28 1.48-.619 1.517-.222.024-.478-.147-.71-.504a40.58 40.58 0 0 0-2.479-3.37l.002-.007c.344-1.723.893-3.48 1.833-5.007 1.176 2.211 1.987 4.911 1.973 7.371Zm-4.413-.057c.83.694 1.058 1.25.872 1.552-.121.198-.424.292-.869.243a43.612 43.612 0 0 0-4.478-.238l-.005-.006C5.21 7.399 3.927 5.623 3.1 3.706c2.813.622 5.857 1.92 8.009 3.719ZM8.274 11.02c1.11-.218 1.717-.039 1.853.304.09.225-.021.525-.336.845a40.982 40.982 0 0 0-2.907 3.33h-.008c-2.238.154-4.567.068-6.751-.44 2.225-1.841 5.242-3.467 8.149-4.039Zm1.267 4.434c.486-.964 1.004-1.326 1.36-1.226.235.067.407.331.47.756.2 1.342.489 2.66.841 3.976a.048.048 0 0 1-.005.006c-1.217 1.613-2.524 3.167-4.163 4.43-.193-2.607.313-5.59 1.497-7.942Zm4.205 1.583c-.432-.882-.4-1.48-.107-1.687.192-.136.498-.11.855.086 1.088.6 2.21 1.16 3.386 1.605l.001.006c.423 1.65.67 3.38.56 5.079-1.957-1.197-3.733-3.124-4.695-5.089Zm3.705-2.174c-.895-.185-1.324-.56-1.296-.9.018-.224.226-.44.593-.59 1.125-.467 2.237-.98 3.283-1.594l.006.003c1.387.66 2.719 1.5 3.79 2.561-1.948.709-4.36.937-6.376.52Zm.732-4.101c-.709.579-1.255.676-1.494.441-.157-.154-.188-.451-.07-.836.377-1.222.67-2.455.912-3.709a.045.045 0 0 0 .006-.002c1.429-.624 2.864-1.197 4.45-1.352-.75 1.999-2.107 4.073-3.804 5.458Z",
    fill: "#146E37"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.546.111c-.94 1.528-1.489 3.284-1.832 5.007l-.002.007c-.236-.286-.549-.631-.82-.945C9.866 2.987 8.732 1.87 7.585.775a12.338 12.338 0 0 1 5.96-.664ZM0 9.457c1.755-.2 3.52-.383 5.267-.439.45-.014.963-.035 1.367-.036l-.005-.006C5.209 7.399 3.926 5.623 3.1 3.706A11.963 11.963 0 0 0 0 9.457Zm3.46 11.205c.826-1.404 1.696-2.796 2.648-4.107.252-.348.537-.749.776-1.057h-.009c-2.238.155-4.566.069-6.75-.44a11.978 11.978 0 0 0 3.335 5.604Zm10.537 3.171c-.531-1.25-1.041-2.51-1.447-3.778-.112-.353-.245-.762-.338-1.095a.042.042 0 0 1-.005.006c-1.217 1.613-2.523 3.166-4.162 4.43 1.979.54 3.9.795 5.952.437Zm8.212-5.463c-1.142-.27-2.279-.577-3.37-.979-.312-.114-.673-.236-.961-.35l.001.006c.423 1.65.67 3.38.56 5.078a12.082 12.082 0 0 0 3.77-3.755Zm1.533-9.088c-.917.703-1.859 1.385-2.854 1.98-.279.167-.595.368-.858.517l.005.003c1.387.66 2.719 1.499 3.79 2.56.254-1.754.234-3.314-.083-5.06Zm-5.669-7.618c-.083 1.315-.185 2.632-.375 3.918-.052.35-.11.756-.17 1.076l.006-.002c1.43-.624 2.864-1.197 4.45-1.352a12.09 12.09 0 0 0-3.91-3.64Z",
    fill: "#64C832"
  }));
};

var SvgSicrediLogoNegative = function SvgSicrediLogoNegative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sicredi-negative-logo",
    "aria-label": "\\xCDcone de logo da Sicredi na varia\\xE7\\xE3o negativa",
    width: 105,
    height: 24,
    viewBox: "0 0 105 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.228 7.859c-.005.902-.256 1.356-.567 1.39-.204.023-.438-.135-.651-.461a37.203 37.203 0 0 0-2.272-3.09l.002-.007c.314-1.579.818-3.19 1.68-4.59 1.077 2.028 1.821 4.503 1.808 6.758Zm-4.045-.053c.762.637.97 1.146.8 1.423-.112.182-.39.268-.797.223a39.98 39.98 0 0 0-4.105-.218l-.005-.006C5.775 7.783 4.598 6.155 3.842 4.397c2.578.57 5.369 1.76 7.34 3.41Zm-2.6 3.296c1.018-.2 1.574-.035 1.699.278.082.206-.02.482-.308.775-.953.97-1.826 1.99-2.665 3.052h-.007c-2.052.142-4.186.063-6.189-.403 2.04-1.687 4.806-3.177 7.47-3.702Zm1.162 4.065c.445-.884.92-1.216 1.248-1.124.214.06.372.303.43.693.183 1.23.448 2.437.77 3.645a.067.067 0 0 1-.004.005c-1.116 1.479-2.314 2.903-3.816 4.061-.178-2.39.287-5.124 1.372-7.28Zm3.854 1.45c-.397-.808-.367-1.357-.099-1.546.177-.124.457-.1.784.08.998.549 2.026 1.063 3.104 1.47l.001.006c.388 1.512.614 3.1.514 4.655-1.794-1.097-3.423-2.863-4.304-4.664Zm3.396-1.992c-.82-.17-1.213-.513-1.188-.825.017-.205.208-.403.544-.542 1.032-.427 2.05-.897 3.01-1.46.002 0 .003.002.005.003 1.271.605 2.492 1.374 3.475 2.347-1.786.65-3.997.859-5.846.477Zm.671-3.76c-.65.53-1.15.62-1.37.405-.143-.141-.172-.414-.063-.767.345-1.12.613-2.25.835-3.4a.042.042 0 0 0 .006-.002c1.31-.572 2.625-1.097 4.08-1.24-.688 1.833-1.933 3.735-3.488 5.004Z",
    fill: "#D7E6C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.42 1.102c-.861 1.4-1.365 3.01-1.68 4.59 0 .001 0 .004-.002.006-.215-.262-.503-.579-.75-.867-.941-1.093-1.98-2.116-3.033-3.12a11.31 11.31 0 0 1 5.465-.609ZM1 9.67c1.61-.184 3.226-.351 4.828-.402.413-.013.883-.033 1.253-.033l-.004-.006c-1.301-1.445-2.478-3.073-3.234-4.83A10.967 10.967 0 0 0 1 9.668Zm3.17 10.272c.758-1.287 1.555-2.563 2.428-3.765.232-.32.492-.686.711-.97l-.007.001c-2.052.142-4.186.063-6.188-.403a10.98 10.98 0 0 0 3.057 5.137Zm9.662 2.907c-.488-1.146-.955-2.3-1.327-3.464-.103-.323-.225-.699-.31-1.003a.036.036 0 0 1-.004.006c-1.116 1.478-2.313 2.901-3.816 4.06 1.814.496 3.576.729 5.457.4Zm7.526-5.009c-1.047-.247-2.089-.528-3.09-.896-.285-.105-.617-.217-.88-.322v.007c.388 1.511.614 3.098.515 4.654a11.074 11.074 0 0 0 3.455-3.443Zm1.406-8.33c-.84.644-1.703 1.27-2.616 1.815-.255.153-.545.338-.786.474l.005.003c1.27.605 2.492 1.374 3.474 2.347a13.794 13.794 0 0 0-.077-4.64Zm-5.196-6.983c-.077 1.205-.17 2.412-.345 3.591-.047.32-.1.693-.155.987l.006-.002c1.31-.573 2.625-1.098 4.079-1.24a11.084 11.084 0 0 0-3.585-3.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m49.092 3.5-.466 3.243h-3.859l.466-3.243h3.86Zm-2.405 16.72h-3.86l1.7-11.807h3.858L46.687 20.22Zm52.99-13.477.466-3.243h3.859l-.466 3.243h-3.86Zm1.918 13.477h-3.859l1.699-11.807h3.859l-1.699 11.807Zm-9.45-4.624c-1.206 1.038-2.14 1.642-3.317 1.665-.341.014-.565-.047-.698-.195-.32-.355-.256-1.333-.037-2.902.425-3.06.884-3.327 3.038-3.327h1.697l-.683 4.759Zm1.777-12.073-.703 4.828a26.183 26.183 0 0 0-3.572-.264c-2.855 0-4.768 1.001-5.48 5.987-.36 2.66-.094 4.444.816 5.454.59.654 1.427.972 2.56.972 1.612 0 3.204-.721 4.736-2.146v1.866h3.092l2.43-16.697h-3.88Zm-16.264 7.408c-1.817 0-2.266.603-2.621 2.514l2.53-.235c1.13-.088 1.656-.303 1.787-1.346.033-.364-.006-.585-.125-.712-.177-.187-.593-.225-1.208-.225-.114 0-.235.001-.363.004Zm4.852-1.533c.589.662.786 1.589.604 2.835-.377 2.513-2.19 3.137-4.99 3.33l-3.33.244c.09 1.362.82 1.617 2.193 1.617 1.184 0 4.04-.136 4.505-.251l.188-.047.022.187c.113.968.44 2.036.455 2.086v.001l.045.142-.14.058c-1.516.618-3.904.9-5.482.9-2.237 0-3.775-.494-4.704-1.509-.945-1.035-1.27-2.65-.993-4.938.556-4.46 2.326-5.966 7.014-5.966 2.316 0 3.825.429 4.612 1.311Zm-11.197-.985h-.748c-1.42 0-2.812.685-4.605 2.278V8.413h-3.068l-1.7 11.808h3.886l.94-6.792c.49-.606 1.85-1.32 2.862-1.32h.83l.029-.13c.007-.03.359-1.542 1.425-3.318l.149-.248Zm-19.848 1.07c1.03-.953 2.532-1.396 4.727-1.396 2.93 0 4.57.526 4.57.526l-.381 2.646s-2.926-.05-3.71-.05c-1.934 0-2.797.437-3.135 3.139-.19 1.457-.123 2.21.227 2.595.283.312.79.434 1.806.434 1.47 0 2.72-.07 3.71-.208l.258-.042-.402 2.79-.1.032c-1.426.455-3.01.55-4.088.55-2.193 0-3.687-.479-4.567-1.465-.914-1.024-1.196-2.624-.865-4.892.331-2.281.933-3.718 1.95-4.66Zm-18 3.213c-2.379-.94-3.254-2.38-2.93-4.818.522-3.68 2.716-4.378 6.583-4.378h5.68l-.474 3.243H35.96c-.86.059-1.274.295-1.45 1.386-.153.98.06 1.146 1.21 1.564l2.967 1.1c2.854 1.076 3.247 2.66 2.956 4.865-.472 3.495-2.032 4.56-6.678 4.56H29l.474-3.242h5.335c2.195 0 2.69-.331 2.883-1.57.129-.96-.091-1.14-1.088-1.495l-3.14-1.215Z",
    fill: "white"
  }));
};

var SvgSicrediLogo = function SvgSicrediLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sicredi-logo",
    "aria-label": "\\xCDcone de logo da Sicredi na varia\\xE7\\xE3o colorida",
    width: 105,
    height: 24,
    viewBox: "0 0 105 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.523 7.482c-.006.984-.28 1.48-.619 1.517-.222.024-.478-.147-.71-.504a40.58 40.58 0 0 0-2.479-3.37l.002-.007c.344-1.723.893-3.48 1.833-5.007 1.176 2.211 1.987 4.911 1.973 7.371Zm-4.413-.057c.83.694 1.058 1.25.872 1.552-.121.198-.424.292-.869.243a43.612 43.612 0 0 0-4.478-.238l-.005-.006C5.21 7.399 3.927 5.623 3.1 3.706c2.813.622 5.857 1.92 8.009 3.719ZM8.274 11.02c1.11-.218 1.717-.039 1.853.304.09.225-.021.525-.336.845a40.982 40.982 0 0 0-2.907 3.33h-.008c-2.238.154-4.567.068-6.751-.44 2.225-1.841 5.242-3.467 8.149-4.039Zm1.267 4.434c.486-.964 1.004-1.326 1.36-1.226.235.067.407.331.47.756.2 1.342.489 2.66.841 3.976a.048.048 0 0 1-.005.006c-1.217 1.613-2.524 3.167-4.163 4.43-.193-2.607.313-5.59 1.497-7.942Zm4.205 1.583c-.432-.882-.4-1.48-.107-1.687.192-.136.498-.11.855.086 1.088.6 2.21 1.16 3.386 1.605l.001.006c.423 1.65.67 3.38.56 5.079-1.957-1.197-3.733-3.124-4.695-5.089Zm3.705-2.174c-.895-.185-1.324-.56-1.296-.9.018-.224.226-.44.593-.59 1.125-.467 2.237-.98 3.283-1.594l.006.003c1.387.66 2.719 1.5 3.79 2.561-1.948.709-4.36.937-6.376.52Zm.732-4.101c-.709.579-1.255.676-1.494.441-.157-.154-.188-.451-.07-.836.377-1.222.67-2.455.912-3.709a.045.045 0 0 0 .006-.002c1.429-.624 2.864-1.197 4.45-1.352-.75 1.999-2.107 4.073-3.804 5.458Z",
    fill: "#146E37"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.546.111c-.94 1.528-1.489 3.284-1.832 5.007l-.002.007c-.236-.286-.549-.631-.82-.945C9.866 2.987 8.732 1.87 7.585.775a12.338 12.338 0 0 1 5.96-.664ZM0 9.457c1.755-.2 3.52-.383 5.267-.439.45-.014.963-.035 1.367-.036l-.005-.006C5.209 7.399 3.926 5.623 3.1 3.706A11.963 11.963 0 0 0 0 9.457Zm3.46 11.205c.826-1.404 1.696-2.796 2.648-4.107.252-.348.537-.749.776-1.057h-.009c-2.238.155-4.566.069-6.75-.44a11.978 11.978 0 0 0 3.335 5.604Zm10.537 3.171c-.531-1.25-1.041-2.51-1.447-3.778-.112-.353-.245-.762-.338-1.095a.042.042 0 0 1-.005.006c-1.217 1.613-2.523 3.166-4.162 4.43 1.979.54 3.9.795 5.952.437Zm8.212-5.463c-1.142-.27-2.279-.577-3.37-.979-.312-.114-.673-.236-.961-.35l.001.006c.423 1.65.67 3.38.56 5.078a12.082 12.082 0 0 0 3.77-3.755Zm1.533-9.088c-.917.703-1.859 1.385-2.854 1.98-.279.167-.595.368-.858.517l.005.003c1.387.66 2.719 1.499 3.79 2.56.254-1.754.234-3.314-.083-5.06Zm-5.669-7.618c-.083 1.315-.185 2.632-.375 3.918-.052.35-.11.756-.17 1.076l.006-.002c1.43-.624 2.864-1.197 4.45-1.352a12.09 12.09 0 0 0-3.91-3.64Z",
    fill: "#64C832"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m49.092 3.5-.466 3.243h-3.859l.466-3.243h3.86Zm-2.405 16.72h-3.86l1.7-11.807h3.858L46.687 20.22Zm52.99-13.477.466-3.243h3.859l-.466 3.243h-3.86Zm1.918 13.477h-3.859l1.699-11.807h3.859l-1.699 11.807Zm-9.45-4.624c-1.206 1.038-2.14 1.642-3.317 1.665-.341.014-.565-.047-.698-.195-.32-.355-.256-1.333-.037-2.902.425-3.06.884-3.327 3.038-3.327h1.697l-.683 4.759Zm1.777-12.073-.703 4.828a26.183 26.183 0 0 0-3.572-.264c-2.855 0-4.768 1.001-5.48 5.987-.36 2.66-.094 4.444.816 5.454.59.654 1.427.972 2.56.972 1.612 0 3.204-.721 4.736-2.146v1.866h3.092l2.43-16.697h-3.88Zm-16.264 7.408c-1.817 0-2.266.603-2.621 2.514l2.53-.235c1.13-.088 1.656-.303 1.787-1.346.033-.364-.006-.585-.125-.712-.177-.187-.593-.225-1.208-.225-.114 0-.235.001-.363.004Zm4.852-1.533c.589.662.786 1.589.604 2.835-.377 2.513-2.19 3.137-4.99 3.33l-3.33.244c.09 1.362.82 1.617 2.193 1.617 1.184 0 4.04-.136 4.505-.251l.188-.047.022.187c.113.968.44 2.036.455 2.086v.001l.045.142-.14.058c-1.516.618-3.904.9-5.482.9-2.237 0-3.775-.494-4.704-1.509-.945-1.035-1.27-2.65-.993-4.938.556-4.46 2.326-5.966 7.014-5.966 2.316 0 3.825.429 4.612 1.311Zm-11.197-.985h-.748c-1.42 0-2.812.685-4.605 2.278V8.413h-3.068l-1.7 11.808h3.886l.94-6.792c.49-.606 1.85-1.32 2.862-1.32h.83l.029-.13c.007-.03.359-1.542 1.425-3.318l.149-.248Zm-19.848 1.07c1.03-.953 2.532-1.396 4.727-1.396 2.93 0 4.57.526 4.57.526l-.381 2.646s-2.926-.05-3.71-.05c-1.934 0-2.797.437-3.135 3.139-.19 1.457-.123 2.21.227 2.595.283.312.79.434 1.806.434 1.47 0 2.72-.07 3.71-.208l.258-.042-.402 2.79-.1.032c-1.426.455-3.01.55-4.088.55-2.193 0-3.687-.479-4.567-1.465-.914-1.024-1.196-2.624-.865-4.892.331-2.281.933-3.718 1.95-4.66Zm-18 3.213c-2.379-.94-3.254-2.38-2.93-4.818.522-3.68 2.716-4.378 6.583-4.378h5.68l-.474 3.243H35.96c-.86.059-1.274.295-1.45 1.386-.153.98.06 1.146 1.21 1.564l2.967 1.1c2.854 1.076 3.247 2.66 2.956 4.865-.472 3.495-2.032 4.56-6.678 4.56H29l.474-3.242h5.335c2.195 0 2.69-.331 2.883-1.57.129-.96-.091-1.14-1.088-1.495l-3.14-1.215Z",
    fill: "#64C832"
  }));
};

export { SvgActionError as ActionError, SvgActionLoadingClock as ActionLoadingClock, SvgActionNotFound as ActionNotFound, SvgActionSuccess as ActionSuccess, SvgDocumentSendSuccess as DocumentSendSuccess, SvgPadlockClosed as PadlockClosed, SvgSicrediIcon as SicrediIcon, SvgSicrediIconNegative as SicrediIconNegative, SvgSicrediLogo as SicrediLogo, SvgSicrediLogoNegative as SicrediLogoNegative };
